import enLocale from 'element-ui/lib/locale/lang/en';
const en = {
  message: {
    tryBtn: 'Free Trial',
    registerBtn: 'Sign Up',
    experienceBtn: 'Try Now',
    enterBtn: 'Enter Now',
    contactBtn: 'Contact Us',
    contactTxt: 'Contact us to start your journey of accelerating global business development with digital intelligence.',
    contactTxtMobile: 'Contact us to start your journey of accelerating <br/> global business development with digital intelligence.',
    contactMobileTxtSolution: "Start Free Trial",
    tips: 'Tips',
    privacyPolicy: 'Privacy Policy',
    terms: 'Terms of use',
    // login
    login: {
      loginUsername: 'Email',
      loginPassword: 'Password',
      loginWelcome: 'Login',
      loginTitle: 'AI-driven innovation for industrial global business development.',
      rememberAccount: 'Remember the account',
      loginTips: `New user? Register Now`,
      loginButton: 'Sign In',
      loginError: 'Sign In failure',
      // register
      registerWelcome: 'Sign Up',
      registerUsername: 'Email',
      registerPassword: 'Password',
      registerConfirmPassword: 'Enter password again',
      registerTips: 'Do you already have an account? Login Now',
      registerButton: 'Sign Up',
      registerError: 'Sign Up failure',
    },
    userEdit: {
      userName: 'Email',
      confirmPassword: 'Confirm password',
      pleaseEnter: 'Please enter',
      msg1: 'Please enter a new password',
      msg2: 'The password length is 8-18 bits, containing at least two types of letters, numbers, and symbols',
      msg3: 'Please enter the password again',
      msg4: 'The two passwords are inconsistent!',
    },
    // 头部
    header: {
      docs: 'User Guide',
      // 顶部导航
      navList: [
        {
          name: "Products",
          children: [
            {
              name: "AI Website Builder",
            },
            {
              name: "Sales Development AI Assistant",
              children: [
                {
                  name: "Market Analytics",
                  desc: "Market Insights & Risks",
                  children: [
                    {
                      name: "Customer Search",
                    },
                  ],
                },
                {
                  name: "Global Customer Acquisition",
                  desc: "Precision Global Decision-Maker Targeting",
                },
                {
                  name: "Customer Insights",
                  desc: "Decode Client Needs & Pain Points",
                  children: [
                    {
                      name: "Customer Management",
                    },
                    {
                      name: "Personalized EDM",
                    },
                  ],
                },
                {
                  name: "Smart Poster Generator",
                  desc: "One-Click Multilingual Posters",
                },
                {
                  name: "Al Meeting Assistant",
                  desc: "Real-Time Translation & Negotiation Aid",
                },
                {
                  name: "Smart Email",
                  desc: "Write Cross-Cultural Emails",
                },
                {
                  name: "Sales Strategy Coach",
                  desc: "Break Sales Deadlocks with Scripts",
                },
              ],
            },
            {
              name: "Pre-sales Consulting AI Assistant",
              children: [
                {
                  name: "Pre-sales Consulting AI Assistant",
                  children: [
                    {
                      name: "Pain Points Discovery Expert",
                      desc: "Pinpoint Core Pain Points",
                    },
                    {
                      name: "Operation Simulation and Analysis Platform",
                      desc: "Generate Custom Proposals",
                    },
                    {
                      name: "Solution Generation Platform",
                      desc: "Simulate Decision Outcomes",
                    },
                    {
                      name: "Demo & Training Platform",
                      desc: "Remote Immersive Demos",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: "About Us",
        },
        {
          name: "Contact Us",
        },
      ],
      stageText1: 'Sales Stage',
      stageText2: 'Target Market​',
      stageText3: 'Prospect Targeting',
      stageText4: 'Prospect Outreach',
      stageText5: 'Meeting Coordination',
      stageText6: 'Needs Discovery',
      stageText7: 'Custom Proposal',
      stageText8: 'Drive Project​',
      loginBtn: 'Login',
      loginOutBtn: 'Logout',
      loginTips: 'please log in first',
      logoutTips: 'Are you sure you want to log out?',
      logoutSuccess: 'You have logged out',
      phone: 'Phone',
    },
    // 首页
    index: {
      banner: {
        btnText: 'Click to try',
        title: "B2B Clients Global <br/> AI Expansion Tools",
        content: 'One-stop AI tools for lead generation <br/> & deal conversion — helping you expand globally.',
        beforeContent: '',
        afterContent: '',
        content2: 'All-In-One Tools for Sales And Pre-Sales - Market Analysis、Customer Acquisition、Sales Coach、Solution Consulting、Demo Delivery.',
        tools: [
          {text: 'Market Analysis'},
          {text: 'Customer Acquisition'},
          {text: 'Automatic Sales Coach'},
          {text: 'Smart Solution Expert'},
          {text: 'DEMO Show Platform'},
        ],
        desc: 'One-stop business development platform for global Enterprise Services and <br/> Non-standard Products Business!',
      },
      business: {
        title: 'Xpirory Covers Over 80% Of The Business Segments In The Enterprise Services and Non-standard Products Business Sales Process',
        btnGroup: {
          btn1: 'Sales Preparation',
          btn2: 'Market Promotion',
          btn3: 'Customer Development',
          btn4: 'Market Analysis',
          btn5: 'Sales Materials',
          btn6: 'Advertising & Business Development',
          btn7: 'Customer Acquisition',
          btn8: 'Customer Analysis',
          btn9: 'Client Communication',
          btn10: 'Pre-Sales Consulting',
          btn11: 'Sales Coach',
          btn12: 'Technical Service',
          btn13: 'Business Activities',
          btn14: 'Bidding & Contracts',
        },
      },
      tool: {
        title: 'Comprehensive system to help you reach markets & grow clients efficiently.',
        content: [
          {
            title: 'AI Lead & Conversion Suite',
            desc: 'If your team prefers DIY,<br>we offer full-featured AI export tools.',
          },
          {
            title: 'Outsourced Operation Service',
            desc: 'If you prefer to focus on core business,<br>we offer hassle-free export services.',
          }
        ]
      },
      valuations: {
        title: 'The voice from users',
        msg1: "When designing cross-border logistics solutions for Russian clients, AI automatically analyzes Moscow's customs clearance policies, and the generated multi-currency quotation is directly signed! The client development module pushes 'China-Europe Railway Express timeliness comparison' in Russian, and we have signed 10+ new clients this month!",
        msg2: "Using AI tools has doubled Amazon product selection efficiency! The market analysis module helps us precisely identify Southeast Asian bestsellers, while the client outreach function auto-generates multilingual development emails. We signed a Malaysian agent last week—3 months faster than traditional methods!",
        msg3: "Struggling with our factory’s foreign trade transition? AI tools generate industry reports in one click, pinpointing European demand for new energy equipment. The pre-sales advisor module even anticipates technical parameters clients may ask about. Now we follow up on 10+ valid inquiries daily!",
        msg4: "When targeting Vietnamese electronics factory clients, the platform auto-collected and deeply analyzed customer info in Vietnamese, quickly identifying key entry points—over 2x faster than manual analysis. Meanwhile, AI simulation uncovered multiple potential optimization areas, cutting upfront research and communication costs by 50%!",
        msg5: "I absolutely love the Xpirory one-stop business development platform! It helps me quickly tackle market analysis, market expansion, client development and more—truly a powerful all-in-one solution!",
        msg6: "Previously, clients struggled to understand the impact of warehouse management solutions, and on-site demo costs were extremely high. We later used remote demos to visually showcase the solution's application to a Turkish factory client, instantly alleviating technical doubts! The project timeline was shortened by at least 45 days compared to expectations.",
        msg7: "Shifting to foreign trade with non-standard products was daunting—how to identify target markets, reach relevant clients, and prepare localized materials? Then we found Xpirory, which solves all these: from market discovery and client acquisition to follow-up, it offers countless user-friendly tools!",
        msg8: "By using the platform's AI tools to conduct insight analysis on customers and combining with our company's business priorities, AI has provided detailed guidance on EDM copywriting. This has increased email optimization efficiency by 200% compared to doing it manually, and the response rate of guided emails has grown by 60%!",
        msg9: "As a heavy user of the Xpirory one-stop business development platform, I can’t help but give it a shoutout! From data-driven insights in market research to precise customer outreach in client development, and efficient execution of omnichannel business development, the platform acts as an all-around assistant, streamlining complex business development workflows into clear, efficient processes.",
        msg10: 'Xpirory helped us uncover hidden needs of French aerospace clients, so we tailored and pushed "innovative 3D printing material" solutions! During industry exhibitions, this generated massive client inquiries, boosting order conversion rates by 60% compared to before!',
        msg11: 'Previously, expanding into the Malaysian market required heavy sales and pre-sales resources. Now with Xpirory, we easily identify key regions and strategies to focus on, and directly access target client data—making overseas expansion smoother while cutting travel costs by over 50%.',
        msg12: 'Had doubts about sensor deployment? A live remote demo showcased data collection in multiple scenarios, and our UK client decided to purchase on the spot!',
        msg13: 'Mr. Wang',
        msg14: 'Mr. Qian',
        msg15: 'Ms. Guan',
        msg16: 'Mr. Wang',
        msg17: 'Mr. Li',
        msg18: 'Mr. Feng',
        msg19: 'Ms. Bai',
        msg20: 'Ms. Lin',
        msg21: 'Cross-border automated technology exporter',
        msg22: 'Cross-border ERP system developer',
        msg23: 'International logistics solution integrator',
        msg24: 'Industrial software developer',
        msg25: 'Manufacturing industry',
        msg26: 'Electronic component supplier',
        msg27: 'Metal processing equipment supplier',
        msg28: 'Industrial IoT service provider',
        msg29: 'Plastic machinery manufacturer',
        msg30: 'Industrial IoT service provider',
      },
      platform: {
        list: [
          {
            content: {
              title: "AI Website Builder: Describe <br/> Your Needs, AI Builds Your Site!",
              info: [
                {
                  title: "AI Smart Website Creation",
                  desc: "Replace traditional time-consuming methods with AI-generated content, images, and layouts.",
                },
                {
                  title: "AI Content Generation",
                  desc: "Automatically craft professional website copy – no more writer’s block.",
                },
                {
                  title: "No-Code Visual Editor",
                  desc: "Easily modify content without coding skills.",
                },
                {
                  title: "All-in-One Hosting",
                  desc: "Launch your business instantly with full-service hosting.",
                },
              ],
            },
          },
          {
            content: {
              title: "Business Tools: Secret <br/> Weapon for Sales Teams",
              info: [
                {
                  title: "Global Customer Search",
                  desc: "Access 20+ data sources (LinkedIn, customs, etc.) to find key contacts worldwide.",
                },
                {
                  title: "Market Analysis",
                  desc: "AI-powered insights for smarter market strategies.",
                },
                {
                  title: "Customer Management",
                  desc: "Track leads, monitor progress, and execute targeted campaigns.",
                },
                {
                  title: "Customer Insights",
                  desc: "AI-driven analysis to optimize client engagement.",
                },
                {
                  title: "Smart EDM Campaigns",
                  desc: "AI-generated personalized emails to boost open/reply rates.",
                },
                {
                  title: "AI Graphics Generator",
                  desc: "Create business development visuals in seconds – no designer needed.",
                },
              ],
            },
          },
          {
            content: {
              title: "Pre-Sales Tools: <br/>Be the Expert Advisor",
              info: [
                {
                  title: "Pain Point Analyzer",
                  desc: "Identify operational challenges and get tailored solutions.",
                },
                {
                  title: "AI Lean Optimization",
                  desc: "Simulate scenarios, analyze data, and implement improvements.",
                },
                {
                  title: "AI Solution Generator",
                  desc: "Instant industry-specific strategies powered by AI.",
                },
                {
                  title: "Demo & Validation",
                  desc: "Test IoT solutions remotely to cut verification costs.",
                },
              ],
            },
          },
        ],
      },
      values: {
        title: 'Core Values',
        list: [
          {
            title: "Quickly Acquire Customers",
            desc: "Global customer data mining to identify precisely the target roles",
          },
          {
            title: "Sales Coach",
            desc: "Personalized challenge coach at different sales stages, with tailored advice to customer respondings.",
          },
          {
            title: "Comprehensive Pre-sales Support",
            desc: "Pre-sales tools cover the entire process from pain points analysis and scenarios simulation, to  solution generation, demos and training.",
          },
          {
            title: "Efficiently Facilitate Transactions",
            desc: "Enables sales team to generate 3-5 more times opportunities in the same time, significantly increase the customer winning rate.",
          },
          // {
          //   title: "AI Industry Diagnosis",
          //   desc: "Custom solutions in seconds. 60% faster project cycles.",
          // },
          // {
          //   title: "Simulation Tools: 90% Lower Risk",
          //   desc: "3D/IoT simulations to pre-test deployments.",
          // },
        ],
      },
      text1: 'AI Solutions',
      text2: 'Smart Outreach Email',
      text3: 'Email Strategy Assistant',
      text4: 'Product Page Design',
      text5: 'Al Meeting / Assistant',
      text6: '1-Click Multi-lang Product Promo Page',
      text7: 'What We Solve?',
      text8: 'Agency Operation Service',
      text9: 'Lead Tools',
      text10: 'Conversion Tools',
      text11: 'Agency Operation Service',
      text12: 'Lead Generation Stage',
      text13: 'Opportunity Conversion Stage',
      text14: 'Which overseas market fits me best?',
      text15: 'What to consider before exploring abroad?',
      text16: 'How to find target clients?',
      text17: 'How to go global with low cost?',
      text18: 'Can a local team handle global markets?',
      text19: 'What if clients don’t respond?',
      text20: 'How to reach many clients efficiently?',
      text21: 'How to communicate without knowing foreign languages?',
      text22: 'How to know an unfamiliar overseas client?',
      text23: 'How can new overseas partners learn fast?',
      text24: 'How to build professional trust quickly?',
      text25: 'How to handle client changes or doubts?',
      text26: 'How to handle multiple client requests efficiently?',
      text27: 'How to cut travel costs?',
      text28: 'What if demo costs are too high?',
      text29: 'What if a deal stalls?',
      text30: 'How to respond to competitors?',
      text31: 'What if client needs are unclear?',
      text32: 'What We Solve ?',
      text33: 'Lead Stage Highlights',
      text34: 'Conversion Stage Highlights',
      text35: 'Lead to Deal: Stages, Time & Cost Analysis',
      text36: 'Market Analysis',
      text37: 'Client Contact',
      text38: 'Client Search',
      text39: 'Info Sharing',
      text40: 'Client Insights',
      text41: 'Meeting Setup',
      text42: 'Needs Discussion',
      text43: 'Product Demo & Training',
      text44: 'Case Sharing',
      text45: 'Sales Strategy',
      text46: 'Products & Solutions<br />Custom Materials',
      text47: 'Business Events',
      text48: 'Sales Cost & Cycle Ratio',
      text49: 'Lead Stage: 5–20%',
      text50: 'Conversion Stage: 80–95%',
    },
    // AI建站
    AIbuilding: {
      contactTxt: 'Ready to revolutionize your website experience?',
      banner: {
        content: 'AI-Powered Website <br/> in 90 Seconds',
        desc: '50% faster loading, 100+ industry templates, hassle-free hosting.',
      },
      advantage: {
        list: [
          {
            title: `<span class="text-primary">300%</span> Faster: <br/> 90s vs. 4-6 Weeks`,
            desc: "Traditional: <br/> 4-6 weeks → AI: 90 seconds",
          },
          {
            title: `Multilingual Auto-Adaptation: Cut Localization Costs by <span class="text-primary">70%</span>`,
            desc: "Auto-Translate to 12 Languages (98% accuracy)%",
          },
          {
            title: `One-stop Worry-Free Trusteeship: <span class="text-primary">80%</span>  Boost in Business Development Efficiency`,
            desc: "Hosting Included: 80% Efficiency <br/> Boost",
          },
          {
            title: `No-Code Design: <br/> <span class="text-primary">10x</span> Faster Edits`,
            desc: "Drag-and-drop + AI layout suggestions. 90% less design time.",
          },
        ],
      },
      platform: {
        title: 'Professional Sites Made Easy',
        list: [
          {
            title: "AI-Optimized Architecture",
            desc: `20M+ industry data points ensure optimal structure. <span class="text-primary nums">80%</span> faster content planning.`,
          },
          {
            title: "Visual Editor <br/>  Studio",
            desc: `Real-time brand compliance checks. <span class="text-primary nums">10x</span> faster iterations.`,
          },
          {

            title: "Auto-Localization",
            desc: `Context-optimized translations. <span class="text-primary nums">70%</span> lower localization costs.`,

          },
        ],
      },
      vs: {
        title: "Traditional vs. AI Website",
        column: {
          items: "",
          others: "Traditional",
          ours: "AI Website",
        },
        list: [
          {
            items: "Development Time",
            others: "4-6 weeks",
            ours: "<90 sec",
          },
          {
            items: "Multi-Language",
            others: "Manual",
            ours: "12 Languages Auto-Generated",
          },
          {
            items: "Mobile Optimization",
            others: "Extra fees",
            ours: "Included & Optimized",
          },
          {
            items: "Maintenance Cost",
            others: "$500+/month",
            ours: "Free Updates",
          },
        ],
      },
    },
    // 业务开拓工具
    business: {
      banner: {
        content: 'AI-Driven Lead Generation & Sales Automation',
        desc: `Smart global prospecting, full-cycle client development, and AI business development to boost growth.`,
      },
      video: {
        tabsList: [
          {
            label: 'Prospecting',
          },
          {
            label: 'CRM',
          },
          {
            label: 'Client Insights',
          },
          {
            label: 'Market Research',
          },
          {
            label: 'Smart EDM',
          },
          {
            label: 'AI Graphics',
          },
        ]
      },
      platform: {
        list: [
          {
            content: {
              title: "Prospecting: <br/> Global Lead Finder",
              info: [
                {
                  title: "360° Client Profiling",
                  subTitle: "Find Key Contacts in 3 Min",
                  desc: `<p>Search by keywords/industry/company</p><p>20+ Data Sources: LinkedIn, customs, reports.</p>`,
                },
                {
                  title: "Supply Chain Mapping",
                  subTitle: "300% Higher Lead Conversion",
                  desc: `<p>Visualize Customer Upstream/Downstream Networks</p><p>Real-Time Tracking of Customer Procurement & Competitor Collaborations</p>`,
                },
              ],
            },
          },
          {
            content: {
              title: "Visualize Client Networks. <br/> Track Procurement Trends.",
              info: [
                {
                  title: "Sales Automation Engine",
                  subTitle: "80% Faster Follow-Ups",
                  desc: `<p>AI Analyzes Email Opens/Company Data.</p><p>Auto-trigger EDM/SMS/Social Outreach.</p>`,
                },
                {
                  title: "Smart EDM Assistant",
                  subTitle: "65% Higher Opens, 40% Replies",
                  desc: `<p>Multi-Theme Templates for Diverse Development Needs</p><p>Data-driven AI Email Optimization</p>`,
                },
              ],
            },
          },
          {
            content: {
              title: "Client Insights: <br/> AI-Powered Strategy",
              info: [
                {
                  title: "Pain Point Analysis",
                  subTitle: "Match Solutions in 3 Min",
                  desc: `<p>AI identifies client needs and aligns your strengths.</p>`,
                },
                {
                  title: "Strategy Simulator",
                  subTitle: "Practical Solutions, Actionable Results",
                  desc: `<p>Actionable steps to close deals faster.</p>`,
                },
              ],
            },
          },
          {
            content: {
              title: "Smart Strategy Analytics",
              info: [
                {
                  title: "Multidimensional Data Panoramic Insights",
                  subTitle: "80% Faster Analysis, 50% Shorter Cycles",
                  desc: `<p>AI aggregates market size, competitors, trends.</p>`,
                },
                {
                  title: "Risk & Strategy Engine",
                  subTitle: "90% Risk Accuracy, 70% Success Rate",
                  desc: `<p>AI generates pricing models and localized strategies.</p>`,
                },
              ],
            },
          },
          {
            content: {
              title: "AI Graphics Factory",
              info: [
                {
                  title: " Text-to-Image Poster Engine",
                  subTitle: "90% Cost Cut, 10x Speed",
                  desc: `<p>Generate visuals from text</p><p>Auto-format for social media</p>`,
                },
                {
                  title: "Brand Visual Management System",
                  subTitle: "Ensure global brand consistency",
                  desc: `<p>Auto-archive for reuse</p><p>Brand Compliance System</p>`,
                },
              ],
            },
          },
        ],
      }
    },
    // 售前顾问支持工具
    preSales: {
      banner: {
        content: "Mining Operational Pain Points <br/> Improve Evaluation and <br/> Practice Of AI Big Models",
        desc: "Provide comprehensive business growth assistance to partners",
      },
      data: {
        list: [
          {
            label: "Increased Business <br/> Opportunities",
          },
          {
            label: "Cost Savings <br/> In Sales",
          },
          {
            label: "Improved Sales <br/> Efficiency",
          },
          {
            label: "Shorten The User <br/> Project Approval Cycle",
          },
        ],
      },
      model: {
        title: 'Mining Operational Pain Points Improve Evaluation <br/> and Practice of AI big Models',
        list: [
          {
            title: `Field Operation - <br/> Pain Points <br/> Analysis Platform`,
            desc: `Based on a scenario mapping and pain-point menu selection approach, we efficiently assist users in matching their optimal digitalization practice solutions, swiftly unlocking a wealth of viable project opportunities.`,
          },
          {
            title: `Operation Solution - <br/> Auto - Generate <br/> AIGC Platform`,
            desc: `By leveraging AI large models, we empower users to effortlessly unlock typical business scenarios across various industries, precisely pinpoint scene-specific pain points, and instantly generate tailored professional solutions. This significantly enhances work efficiency and reduces business development costs.`,
          },
          {
            title: `Operation Simulation - <br/> Auto - Analyze <br/> AIGC Software`,
            desc: `Operation Simulation - Auto - Analyze AIGC Software is an AI simulation tool designed for on-site operational improvement analysis. It diagnoses potential areas for operational enhancements and recommends corresponding optimization strategies, facilitating users in accelerating their enterprise's digital and intelligent transformation.`,
          },
          {
            title: `Field Operation - <br/>  Improvement <br/> PoC Platform`,
            desc: `Users remotely control IoT products through real-scenario operations, personally experiencing the optimization they bring to on-site management and workflow. This hands-on approach allows for  understanding of product features and enables real-time verification of solution effectiveness, significantly reducing the validation cycle and lowering associated costs.`,
          },
        ],
      },
      platform: {
        list: [
          {
            tabTitle: `Pain Points <br/> Analysis Platform`,
            title: `Field Operation -  <br/> Pain Points Analysis Platform`,
            desc: `Based on a scenario mapping and pain-point menu selection approach, we efficiently assist users in matching their optimal digitalization practice solutions, swiftly unlocking a wealth of viable project opportunities.`,
            videoList: [
              {
                label: `Industry Selection`,
                desc: `A comprehensive overview of various industries, streamlining the need for dedicated industry consultant resources.`,
              },
              {
                label: `Scene Pain Point Filtering`,
                desc: `A comprehensive overview of various industries, streamlining the need for dedicated industry consultant resources.`,
              },
              {
                label: `Solution Browsing`,
                desc: `Rapid matching with a diverse range of IoT application solutions tailored to specific needs.`,
              },
              {
                label: `Budget and ROI Estimation`,
                desc: `Efficient projections of investment budgets alongside swift Return On Investment (ROI) estimates.`,
              },
            ],
          },
          {
            tabTitle: `Operation Solution - Auto - <br/> Generate AIGC Platform`,
            title: `Operation Solution - Auto - <br/>Generate AIGC Platform`,
            desc: `By leveraging AI large models, we empower users to effortlessly unlock typical business scenarios across various industries, precisely pinpoint scene-specific pain points, and instantly generate tailored professional solutions. This significantly enhances work efficiency and reduces business development costs.`,
            videoList: [
              {
                label: "Industry Selection",
                desc: `Covers a wide range of industry scenarios, minimizing the need for extensive industry consultant resources.`,
              },
              {
                label: "Pain Point Identification in Scenarios",
                desc: `Visually presents scenarios and their pain points, precisely uncovering demand opportunities.`,
              },
              {
                label: `AI-driven Proposal Generation`,
                desc: `One-click AI generation of proposals and detailed content, significantly enhancing productivity.`,
              },
              {
                label: `Rapid Online Proposal Editing`,
                desc: `Enables efficient editing of proposals online for swift content creation.`,
              },
              {
                label: `Extensive Material Library`,
                desc: `Offers a diverse selection of materials to facilitate rapid personalized modifications.`,
              },
              {
                label: `Customizable Templates & Materials`,
                desc: `Supports uploading personalized templates and materials to meet varied user needs.`,
              },
              {
                label: `Swift Budgeting & ROI Estimation`,
                desc: `Provides tools such as research checklists, budget templates, and ROI calculation sheets to swiftly overcome obstacles in project initiation.`,
              },
            ],
          },
          {
            tabTitle: `Operation Simulation - Auto - <br/>Analyze AIGC Software`,
            title: `Operation Simulation - Auto - <br/>Analyze AIGC Software`,
            desc: `Operation Simulation - Auto - Analyze AIGC Software is an AI simulation tool designed for on-site operational improvement analysis. It diagnoses potential areas for operational enhancements and recommends corresponding optimization strategies, facilitating users in accelerating their enterprise's digital and intelligent transformation.`,
            videoList: [
              {
                label: `Basic Data Input`,
                desc: `Imports existing operational behavior data to establish a simulation analysis model.`,
              },
              {
                label: `Visualized Simulation Modeling`,
                desc: `Creates a visualized map for an intuitive representation of operational dynamics.`,
              },
              {
                label: `AI-powered Diagnostic Analysis`,
                desc: `Leverages AI expert systems to analyze potential pain points and recommend mitigation strategies.`,
              },
              {
                label: `Optimization Comparison`,
                desc: `Facilitates the creation of personalized improvement plans with ease, allowing for straightforward comparison of anticipated outcomes.`,
              },
            ],
          },
          {
            tabTitle: `Improvement <br/>PoC Platform`,
            title: `Field Operation - <br/>Improvement PoC Platform`,
            desc: `Users remotely control IoT products through real-scenario operations, personally experiencing the optimization they bring to on-site management and workflow. This hands-on approach allows for  understanding of product features and enables real-time verification of solution effectiveness, significantly reducing the validation cycle and lowering associated costs.`,
            videoList: [
              {
                label: `Scene Selection`,
                desc: `A diverse range of realistic practice sites to cater to a variety of Demo implementation requirements.`,
              },
              {
                label: `Resource Empowerment Visualization`,
                desc: `Provides a clear depiction of how multiple IoT products enhance operational resources on-site.`,
              },
              {
                label: `Customizable Parameters`,
                desc: `Supports self-configuration of various parameters within the scenario, offering personalized in-depth experiences.`,
              },
              {
                label: `Real-time Control of Physical Objects`,
                desc: `Immersive remote operation mode enables autonomous observation from multiple angles.`,
              },
              {
                label: `Business Improvement Effect Immersion`,
                desc: `Enables rapid verification and demonstration of solution practical application effects anytime, anywhere, facilitating accelerated understanding at a reduced cost.`,
              },
            ],
          },
        ],
      },
      core: {
        title: `Core Functional Value`,
        list: [
          {
            label: `Industry Solution <br/> Empowerment`,
            desc: `Presents a comprehensive panorama of industries alongside core scenario-based application solutions, offering abundant inspiration and of industry expertise.`,
          },
          {
            label: `Multi-IoT Convergence for <br/> High ROI`,
            desc: `Each scenario evolves from single IoT applications to integrated multi-IoT solutions, empowering multiple digital aspects to enhance efficiency and yield higher ROIs.`,
          },
          {
            label: `Opportunity Cultivation <br/> for Growth`,
            desc: `Assists partners in unearthing new pain points among existing clients and swiftly tapping into new scenarios with prospective clients, generating substantial valid demands.`,
          },
          {
            label: `Accelerated Project <br/> Advancement`,
            desc: `Expedites adaptation to digitalization scenarios, pinpoints pain points, and assesses ROIs rapidly, with swift Demo validations that boost communication efficiency.`,
          },
          {
            label: `Reduced Business Development <br/> Costs`,
            desc: `Enables efficient engagement with multiple scenarios and pain points in a single visit through a "menu-style" interaction; remote Demo validations cut down on travel expenses.`,
          },
          {
            label: `Diminished Dependence <br/> on Specialist Talent`,
            desc: `Automatically generated AI-powered solutions reduce reliance on specialized consultants, thereby lowering talent investment costs.`,
          },
        ],
      },
    },
    // 关于我们
    about: {
      contactTxt: 'Contact us to start your journey of accelerating global business development with digital intelligence.',
      banner: {
        content: `AI-powered, all-in-one global expansion platform for B2B companies.`,
        tools: 'Analytics, Leads, Contact, Guidance, Consulting, Support',
        desc: 'One-stop AI tools for lead generation & deal conversion — helping you expand globally.',
      },
      data: {
        list: [
          {
            label: "Lower Sales Cost",
          },
          {
            label: "Higher Customer Development Efficiency",
          },
          {
            label: "Higher customer winning Rate",
          },
          {
            label: "Shorten Sales Cycle",
          },
        ],
      },
      introduction: {
        title: "Xpirory",
        content: `
          <p>
          Headquartered in Singapore, Xpirory is an innovative technology company dedicated to providing one-stop global sales and pre-sales consulting tools for enterprise services and non-standard products business providers. With AI-driven technology as our core competitive edge, we strive to assist businesses in breaking through geographical constraints and embarking on a new journey of efficient and precise business expansion in the global market through intelligent tools and data insights.
          </p>
          <p>
            We possess an enterprise-level AI business development platform that deeply integrates full-process services including market analysis, global customer acquisition, customer communication, strategic guidance, pre-sales consulting, and technical support, forming a complete closed loop from market insight to customer conversion. Through AI algorithms, we accurately capture global industry trends and customer needs, and combine diversified AI automation business development tools to assist enterprises in efficiently reaching target customers, optimizing sales processes, and improving lead conversion rates, making global business development easy and convenient.
          </p>
          <p>
            Our Vision: to become the core driving force for the development of global enterprise services and non-standard products business!
          </p>
          <p>
            Our Mission: To empower enterprises with artificial intelligence technology to achieve an intelligent business development model and accelerate the expansion into the global market!
          </p>
          <p>
            Xpirory will continue to invest in AI technology research and development, deeply explore industry scenarios with a global perspective, and serve global enterprise services and non-standard products business providers. At the same time, we also look forward to collaborating with more partners to jointly explore the deep integration of AI and business development, promote the intelligent transformation of business development models, and help global enterprise services and non-standard products business providers seize the initiative in the digital wave, creating a smart future together.
          </p>
          <p>
            Xpirory, connecting global markets through technology and reshaping the paradigm with AI!
          </p>
        `,
      },
    },
    // 定价
    pricing: {
      contactTxt: 'Contact us to start your journey of accelerating global business development with digital intelligence.',
      banner: {
        content: `All-in-One Platform Plans`,
        desc: "AI-driven solutions for global market expansion.",
      },
      vs: {
        column: {
          items: "",
          freeVision: "Free Tier",
          freeVisionInfo: `Overview...`,
          enterpriseVision: "Enterprise",
          enterpriseVisionInfo: `Overview`,
          proVision: "Advanced",
          proVisionInfo: `Overview...`,
        },
        list: [
          {
            items: "Use Cases",
            freeVision: "",
            freeVisionInfo: `Overview...`,
            enterpriseVision: "",
            enterpriseVisionInfo: `Overview...`,
            proVision: "",
            proVisionInfo: `Overview...`,
          },
          {
            items: "Features",
            freeVision: "",
            enterpriseVision: "",
            proVision: "",
            children: [
              {
                items: "Key Functions 1",
              },
              {
                items: "Key Functions 2",
              },
              {
                items: "Key Functions 3",
              },
              {
                items: "Key Functions 4",
              },
              {
                items: "Key Functions 5",
              },
              {
                items: "Key Functions 6",
              },
              {
                items: "Key Functions 7",
              },
              {
                items: "Key Functions 8",
              },
            ],
          },
          {
            items: "Standard Price",
            freeVision: `XX<span class="fs_16 ml-1">$/hour</span>`,
            freeVisionButton: "Enter",
            enterpriseVision: `XX<span class="fs_16 ml-1">$/hour</span>`,
            enterpriseVisionButton: "Try Now",
            proVision: `Custom Quote`,
            proVisionButton: "Contact Us",
          },
        ],
      },
    },
    // 联系我们
    contact: {
      banner: {
        title: 'Contact Us',
        desc: 'Have questions about our products, company, or anything else?',
      },
      main: {
        title: 'Want To Learn More?',
        desc: 'Please fill out the form below, and we will get back to you as soon as possible!',
        msg1: 'For more updates,<br/>feel free to follow us on social media!',
        msg2: 'Have a question, feedback, or just want to say hello?<br/>We look forward to all forms of interaction!',
        formItem1: 'First Name',
        formItem2: 'Last Name',
        formItem3: 'Phone',
        formItem4: 'Email',
        formItem5: 'Company Name',
        formItem6: 'Country/Region',
        formItem7: 'Message',
        submitBtn: 'Submit',
        successMsg: 'Submit successfully!',
        failedMsg: 'System exception!',
        msg3: '基于您的业务领域、产品场景，精准匹配<span>3家潜在目标客户</span>',
        msg4: '附赠<span>其中一家客户的关键联系人(电话/邮箱)</span>，直接触达决策层',
        msg5: '<span>定制化业务开发信</span>(深度结合双方信息撰写，可直接使用)',
        msg6: '<span>零成本获取</span>全球业务AI开拓工具带来的惊人效果！',
      }
    },
    // 售前顾问支持工具New
    supportTools: {
      banner: {
        title: 'AI Pre-sales Consulting Assistant: ',
        content: `Four leading pre-sales enablement platforms <br> boost qualified lead generation by 300-500% and <br>shorten project  implementation cycles by 30-40%.`,
        desc: "Quickly discover pain points, easily simulate and analyze operations, automatically generate solutions, and effectively demo products and do trainnings.",
        btnText: 'Request a Trial',
      },
      tryBtn: 'Click to try',
      platform: {
        btnGroup: {
          btn1: 'Pain Points Discovery Expert',
          btn2: 'Operation Simulation and Analysis Platform',
          btn3: 'Solution Generation Platform',
          btn4: 'Demo & Training Platform',
        },
        list: [
          {
            title: `Find Key Pain Points and High-ROI<br> Requirements 300–500% Faster.`,
            videoList: [
              {
                label: `Multi-industry Scenario Configuration`,
                desc: `Breaks down cross-industry experience barriers, empowers pre-sales with multi-industry expertise, and reduces consultants' time commitment.`,
              },
              {
                label: `High-ROI Pain Point Collection`,
                desc: `Structural output of business pain points, enabling every frontline employee to have expert-level pain point discovery capabilities.`,
              },
              {
                label: `Matching the Best Practice Solution`,
                desc: `Provide best practice solutions to each pain point to efficiently pinpoint customer requirements.`,
              },
              {
                label: `AI Intelligent Search Assistant`,
                desc: `A dedicated AI expert consultant that responds anytime, efficiently summarizing and extracting vast business knowledge.`,
              },
            ],
          },
          {
            title: `Boosts Efficiency Of Operation Sim/Analysis<br> And Improvement Evaluation .`,
            videoList: [
              {
                label: "Easily Build Resource Analysis Models",
                desc: `Supports customized resource behavior data to establish a foundation for  multi-dimensional operational analysis.`,
              },
              {
                label: "Visualized Operational Simulation Analysis",
                desc: `Visualize operation simulation with dynamic resources status to display various aspects of operational KPIs.`,
              },
              {
                label: `AI Intelligent Analysis & Solution Recommendation`,
                desc: `AI comprehensively and accurately discovers potential pain points, quickly estimates quantifiable improvement effects, and reduces the risk of misjudging investment direction.`,
              },
              {
                label: `Optimization Solutions in Quantitative Comparison`,
                desc: `Visually compares changes in various KPIs of multiple optimizations, providing a strong basis for decision-making and greatly shortening project initiation time.`,
              },
            ],
          },
          {
            title: `AI Solution Expert Can Easily Generate Solutions In Multi-Language, <br>Boosting Solution Creation Efficiency By 300-500%.`,
            videoList: [
              {
                label: `Professional Content Generation`,
                desc: `Supports specifying multiple reference documents to make AI-generated content more precise and professional.`,
              },
              {
                label: `Output Language Selection`,
                desc: `Multiple language options make it easy to serve customers worldwide.`,
              },
              {
                label: `Controllable Solution Templates`,
                desc: `Easily create controllable solution templates to better meet enterprise application requirements.`,
              },
              {
                label: `Fast Online Editing`,
                desc: `Multiple online editing tools and assets help efficiently finalize solution adjustments.`,
              },
              {
                label: `Solution Sharing between team members`,
                desc: `One-click collection of established standard solutions for quick team sharing.`,
              },
              {
                label: `Scenario Map Association`,
                desc: `Customized industry maps with categorized pain points make application scenarios clear and easy for solution recommendation.`,
              },
            ],
          },
          {
            title: `Remote Demo Removes Setup Limits,<br> Cuts Cost By 90%.`,
            videoList: [
              {
                label: `Flexible Playgound Selection`,
                desc: `Rich real-world scenarios with no setup needed, meeting diverse demo needs at low cost.`,
              },
              {
                label: `Operation Resources Empowerment Display`,
                desc: `Clearly demonstrates how operation resources are empowered, making abstract solutions easily understood.`,
              },
              {
                label: `Customizable Parameters Configuration`,
                desc: `Supports custom configuration of various on-site equipment parameters, quickly giving users a comprehensive understanding of the equipment.`,
              },
              {
                label: `Live Operation of Remote Physical Objects`,
                desc: `Multi-dimentional cameras working together to achieve an immersive demo experience at a low cost.`,
              },
              {
                label: `Open Playground API Integration`,
                desc: `Supports integrating with your own systems to achieve combined software-hardware demonstrations.`,
              },
            ],
          },
        ],
      },
      valuations: {
        msg1: "When designing cross-border logistics solutions for Russian clients, AI automatically analyzes Moscow's customs clearance policies, and the generated multi-currency quotation is directly signed! The client development module pushes 'China-Europe Railway Express timeliness comparison' in Russian, and we have signed 10+ new clients this month!",
        msg2: 'Used to feel like we were "guessing blindly" when discussing needs with clients. Now, using scenario maps to filter pain points, clients can directly identify their issues—one even said, "This is exactly our workshop problem!" Effective lead generation efficiency has doubled.',
        msg3: 'After integrating the MES system into the demo platform, we directly connected its point information collection function with hardware, allowing clients to visually see how software and hardware work together at low cost. One client commented, "This is much more efficient than our manual scanning!" As a result, we secured nearly $1M in additional orders for on-site collection hardware.',
        msg4: 'Previously, we had to solve sales challenges with clients independently. To our surprise, Xpirory’s "Dilemma Breakthrough Master" offers detailed guidance on common sales obstacles, summarizing numerous scenarios we frequently face. This has been incredibly helpful for advancing our business!',
        msg5: 'The workshop supervisor was initially resistant to new tools but now checks simulation results on his phone daily, saying, "Easier than using TikTok—I’ve taught three team leaders already!"',
        msg6: "Time zone differences made communicating on overseas factory projects a headache. Now, sharing real-time simulation visuals lets German engineers adjust parameters on the fly, cutting project cycles by 40%.",
        msg7: "When presenting a warehouse optimization plan to client executives, a remote live demo showcased real-world application effects. The logistics director immediately grasped the plan’s feasibility and approved launching a smart warehouse project—something that would’ve required multiple back-and-forth meetings before!",
        msg8: "When presenting a plan to an automotive factory client, they suddenly requested a directional adjustment. Using our solution generation platform, we quickly accessed relevant reference materials and generated a customized new plan on the spot. This locked in the client’s vision in one meeting, eliminating the need for days of back-and-forth revisions and travel for negotiations.",
        msg9: 'During a live operational simulation analysis for a client last week, the screen clearly showed excessive forklift idle time. Client engineers crowded around, saying, "So our vehicle utilization is this poor!" They immediately decided to launch a special optimization for forklifts.',
        msg10: 'We used to only take on home appliance clients, but now with the industry panorama map, we even dare to tackle aerospace subcontracting projects. The sales manager said, "AI knows more industries than our senior consultants!"',
        msg11: 'New sales hires get up to speed quickly with our solution generation platform. Even without prior medical industry experience, they can easily create tailored proposals by matching client scenarios, saying, "AI knows it all—meeting clients alone isn’t daunting at all."',
        msg12: 'When explaining AGV collaborative management logic to clients, they often struggled to understand. Using our demo platform, we operated via remote live visuals, and clients grasped it instantly. The intuitive demonstration gave them a clear concept of abstract logic—no need to transport actual AGVs to the site for demos.',
        msg13: 'When improving an electronics factory, we used a simulation analysis platform for evaluation. AI automatically recommended multiple optimization plans, and through intuitive data comparisons, the client quickly identified which area to prioritize for improvement.',
        msg14: 'Manager Guan',
        msg15: 'Mr. Zhu',
        msg16: 'Ms. Ding',
        msg17: 'Mr. Jiang',
        msg18: 'Mr. Li',
        msg19: 'Mr. Zhai',
        msg20: 'Mr. Wang',
        msg21: 'Mr. Guang',
        msg22: 'Ms. Liu',
        msg23: 'International logistics solution integrator',
        msg24: 'A certain manufacturing integrator',
        msg25: 'Automotive Industry',
        msg26: 'A solutions provider',
        msg27: 'Engineering firm',
        msg28: 'Tire Industry',
        msg29: 'A forklift truck modification solutions provider',
        msg30: 'Metalworking Equipment Supplier',
        msg31: 'System developer',
        msg32: 'Integrator',
        msg33: 'Industrial IoT Service Provider',
      },
      values: {
        title: "Core Values",
        list: [
          {
            title: "Deeply discovers customer pain points and precisely position operation issues by 80% increasement.",
          },
          {
            title: "Instantly simulating operational trends and visualizing optimization insights, multiply the speed of customer understanding.",
          },
          {
            title: "Fast generating solutions and efficient responding to customer requirements increase customer satisfaction by 50%.",
          },
          {
            title: "Remote live demo presentations efficiently showcase solution value in a low-cost way, increase customer decision efficiency by 50%.",
          },
        ],
      },
    },
    // AI销售业务开拓助手
    developTools: {
      banner: {
        title: 'AI Sales Development Assistant:',
        content: `Six core functions boost customer development efficiency<br>by 300-500% and reduce sales costs by 40-50%.`,
        desc: "Finds global leads, targets clients and handles sales challenges!",
      },
      btnText: 'Market<br>Analytics',
      btnText2: 'Global Customer<br> Acquisition',
      btnText3: 'Customer<br>Insights',
      btnText4: 'Smart Poster <br> Generator',
      btnText5: 'Al Meeting <br> Assistant',
      btnText6: 'Smart <br> Email',
      btnText7: 'Sales Strategy<br> Coach',
      viewDetails: 'View details',
      platform: {
        list: [
          {
            title: `Precisely Analyzes Target Markets, Reducing Pitfall Risks By 80%.`,
            videoList: [
              {
                label: `Data Radar`,
                desc: `Integrates industry trends, customer pain points, industry chain (upstream/downstream), competition and differentiation, and government policies, etc.`,
              },
              {
                label: `Market Navigation`,
                desc: `Analyzes entry routes, market positioning, and operational strategies in target markets to help navigate business development development precisely.`,
              },
              {
                label: `Risk Assessment`,
                desc: `Combines political, financial, regulatory, and other information to assess market risks and exit strategies, enabling proactive planning.`,
              },
            ],
          },
          {
            title: `Global Customer Radar For Precise Target Acquisition, Boosting Efficiency By 300-500%.`,
            videoList: [
              {
                label: "Multi-dimensional Customer Search",
                desc: `Searches for customers by buyers, suppliers, keywords, etc., to obtain customer info and quickly find target customers.`,
              },
              {
                label: "Supply Chain Penetration",
                desc: `360° analysis of upstream and downstream relationships to quickly sort out the customer network.`,
              },
              {
                label: `Competitor Tracing`,
                desc: `Trace clues to find competitors’ customers.`,
              },
            ],
          },
          {
            title: `Customer Insights: Accurately Grasp Company Background Info, Increasing Customer Winning Rate By 50-80%.`,
            videoList: [
              {
                label: `Pain Point Scan`,
                desc: `Analyzes all available customer data to identify typical industry pain points and potential cooperation opportunities with target customer.`,
              },
              {
                label: `Strategy Analysis`,
                desc: `Provides strategic business development advice with background information of both supplier and customer.`,
              },
              {
                label: `Risk Assessment`,
                desc: `Provides competitive and partnership risk evaluations based on the market info of customer and competitors.`,
              },
            ],
          },
          {
            title: `Efficient Creation Of Business Development Materials, Reducing Costs By 80%.`,
            videoList: [
              {
                label: `Magic Image Generator`,
                desc: `Offers multiple industry and scenario styles with quick usage guides to efficiently generate professional images.`,
              },
              {
                label: `Sales Materials Knowledge Base`,
                desc: `Builds a rich, ready-to-use library of sales materials for AI usage.`,
              },
              {
                label: `Poster Expert`,
                desc: `Enables fast creation of multi-language business development posters using the knowledge base without need of professional editing tools, full control over style and content.`,
              },
            ],
          },
          {
            title: `Accessible voice communication, AI intelligent assistance greatly improves communication efficiency`,
            videoList: [
              {
                label: `Low-latency Speech Simultaneous Interpretation`,
                desc: `With low-latency simultaneous interpretation, speak Chinese directly, and the other party can hear fluent translated English without Chinese original sound interference. Cross-border meetings can be as easy as communicating with locals.`,
              },
              {
                label: `Real-time AI Strategy Recommendations`,
                desc: `Automatically analyze the other party's remarks during the meeting (e.g., questions, pressure, challenges), push response strategies in real time, and help business personnel cope easily.`,
              },
              {
                label: `Intelligent Term Interpretation`,
                desc: `Automatically capture industry terms or trending terms, provide real-time term explanations, eliminate knowledge gaps, avoid semantic deviations, and facilitate smooth communication with customers.`,
              },
              {
                label: `One-click Conversation Summary`,
                desc: `After the meeting, summarize key points and action plans with one click, eliminating manual sorting and promoting work efficiently.`,
              },
              {
                label: `Invisible Mode + Small Window Interaction`,
                desc: `Automatically hide after screen projection (not displayed on the other party's computer screen) and support minimized display via small window mode, without interfering with normal screen projection and communication.`,
              },
            ],
          },
          {
            title: `Barrier-free language communication; AI intelligent assistance greatly boosts communication efficiency`,
            videoList: [
              {
                label: `AI Intelligent Email Script Generation`,
                desc: `Combined with sales stages and business backgrounds, it automatically generates personalized email scripts and guidance based on sales challenges at different stages`,
              },
              {
                label: `Multilingual Business Email Translation`,
                desc: `Provides multilingual translation that covers not only text but also business communication customs in the other party’s culture`,
              },
              {
                label: `Convenient Email Templates`,
                desc: `Supports pre-editing of multiple commonly used email templates for easy sending`,
              },
            ],
          },
          {
            title: `Sales Strategy Coach: Increases Customer Conversion Rate By 50-80%.`,
            videoList: [
              {
                label: `Sales Challenges Library`,
                desc: `Shares various sales challenges across different stages to quickly find references.`,
              },
              {
                label: `AI Sales Coach`,
                desc: `Automatically generates methods and suggestions to handle sales challenges.`,
              },
              {
                label: `Personalized Guidance`,
                desc: `Deeply integrates your company and customer information to tailor exclusive guidance.`,
              },
            ],
          },
        ],
      },
      valuations: {
        msg1: "When designing cross-border logistics solutions for Russian clients, AI automatically analyzes Moscow's customs clearance policies, and the generated multi-currency quotation is directly signed! The client development module pushes 'China-Europe Railway Express timeliness comparison' in Russian, and we have signed 10+ new clients this month!",
        msg2: 'When bidding for a Dubai smart transportation project, AI-generated Arabic dynamic flowcharts showcased our V2X technology advantages step-by-step. Evaluation experts called it "the clearest proposal." After winning the bid, the client voluntarily added 5G base station orders.',
        msg3: "When quoting for a Kenya irrigation project, AI alerted us that clients might question equipment corrosion resistance. We pre-prepared salt spray test reports and local success cases, which directly addressed concerns during negotiations. The project's profit margin was 8% higher than expected!",
        msg4: 'We were about to abandon the Swedish medical equipment market, but a market analysis module helped us reevaluate it. We found a clear growth in demand for home care equipment, quickly adjusted our promoted products and strategies—and saw a 3x increase in inquiries within two months!',
        msg5: 'Highly recommend this user-friendly graphic poster maker. With templates for multiple scenarios/styles and quick usage guides, it significantly reduces the complexity and cost of creating business development materials, enabling efficient generation of professional visuals.',
        msg6: 'Sales reps used to spend ages crafting emails that never fully addressed client concerns. Now, with the Dilemma Strategy Master feature, AI provides step-by-step guidance—letting every rep easily draft high-quality emails. Client deal cycles have shortened by at least 30%!',
        msg7: 'Conducting client background checks used to take ages—online info was fragmented, and translating foreign languages with tools was a slog. Now, just select the target language, and AI scans client-related news in minutes, providing market penetration advice and specific business integration points. This has cut time costs equivalent to 4-5 full-time staff!',
        msg8: "When presenting a warehouse optimization plan to client executives, a remote live demo was used for on-site demonstration. The logistics director immediately grasped the plan's real-world application effects and approved the project to build a smart warehouse—something that would have required multiple back-and-forth meetings in the past!",
        msg9: 'Previously, responding to client queries about products, prices, and delivery times via email was often challenging. Now, with the help of an AI sales expert that provides professional guidance on sales challenges and auto-generates email content, our communication with clients has become smoother and more efficient, making project advancement significantly easier.',
        msg10: 'AI analyzed global machinery exhibition data, and the generated Russian-version processing efficiency comparison report became the best conversation starter! The market lead acquisition module automatically matched Russian infrastructure projects, resulting in over 120 new client leads during the Moscow exhibition.',
        msg11: "We truly realized how simple business development could be only after using this business development tool—it has saved our team massive time on business development, and we'll keep using it indefinitely!",
        msg12: 'When developing a connected car solution for an automotive client, our client insights revealed a patent gap in their technology portfolio, which perfectly matched one of our customized modules. We immediately engaged the client, who said, "You’ve completed our technology puzzle." Through persistent efforts, we successfully secured the project!',
        msg13: "In the past, we had to solve sales challenges with clients on our own. Unexpectedly, Xpirory’s Dilemma Breaker Master offers detailed guidance on common sales hurdles, summarizing numerous scenarios we frequently face. This has been incredibly helpful for advancing our business!",
        msg14: 'Mr. Zhou',
        msg15: 'Mr. Wang',
        msg16: 'Ms. Zhou',
        msg17: 'Ms. Shi',
        msg18: 'Mr. Jiang',
        msg19: 'Mr. Feng',
        msg20: 'Ms. Xi',
        msg21: 'Mr. Li',
        msg22: 'Mr. Zhao',
        msg23: 'Mr. Sun',
        msg24: 'Ms. Chen',
        msg25: 'Medical Equipment Provider',
        msg26: 'Software Integrator',
        msg27: 'International Logistics Solutions Integrator',
        msg28: 'Medical IT Provider',
        msg29: 'A Solutions Provider',
        msg30: 'Manufacturing Industry',
        msg31: 'Software Outsourcer',
        msg32: 'Metal Processing Equipment Supplier',
        msg33: 'System Development Integrator',
        msg34: 'System Developer',
        msg35: 'An Integrator',
        msg36: 'Industrial IoT Service Provider',
      },
      values: {
        title: "Core Values",
        list: [
          {
            title: "Precisely analyzes target markets, reducing risk of pitfalls by 80%.",
          },
          {
            title: "Global Customer Radar for precise target acquisition, boosting efficiency by 300-500%.",
          },
          {
            title: "Customer Insights: accurately grasp company background info, increasing customer winning rate by 50-80%.",
          },
          {
            title: "Sales Strategy Coach: increases customer winning rate by 50-80%.",
          },
          {
            title: "Efficient creation of business development materials, reducing costs by 80%.",
          },
        ],
      },
    },
    // 解决方案生成平台
    solution: {
      banner: {
        title: 'Solution Generation Platform',
        content: `AI Learns Your Knowledge<br> Base + Controlled Templates,<br>3-Min Custom Proposals`,
      },
      title1: 'Xpirory Solution Generation Platform',
      desc1: 'Generates multilingual professional proposals by understanding your knowledge base and custom templates.',
      title2: 'Multilingual AI Solutions Expert: Generate proposals<br>effortlessly with 300%-500% efficiency boost.​',
      platform: {
        list: [
          {
            title: `Knowledge-Driven Content`,
            desc: 'Generates expert-level content by referencing multiple documents',
          },
          {
            title: `PPT Compatibility`,
            desc: 'Edit proposals using familiar PowerPoint tools with AI content generation',
          },
          {
            title: `Multilingual Output`,
            desc: 'Generate proposals in 10+ languages',
          },
          {
            title: `Customizable Templates`,
            desc: 'Build and control proposal templates aligned with business needs',
          },
          {
            title: `Real-Time Editing`,
            desc: 'Modify proposals instantly with built-in tools',
          },
          {
            title: `Team Sharing & Rapid Tuning`,
            desc: 'Share approved proposals instantly and adjust via prompts',
          },
          {
            title: `Scene Mapping`,
            desc: 'Visually categorize pain points and solutions by industry',
          },
        ],
      },
      title3: 'Xpirory Unique Advantages',
      title4: 'Use Cases',
      title5: 'Performance Comparison',
      advantage: [
        {
          title: 'Business-Accurate Proposals',
          desc: 'Generates enterprise-ready solutions (not generic descriptions)',
        },
        {
          title: 'Template & Content Control',
          desc: 'Ensures proposals strictly align with your knowledge base',
        },
        {
          title: '1-Click Reuse & Tuning',
          desc: 'Adapt existing proposals to new clients in 1 minute with multilingual sync',
        },
      ],
      scene: [
        {
          title: 'Rapid Custom Proposals',
          desc: 'Instantly tailor solutions without wasting presales resources',
        },
        {
          title: 'Global Multilingual Delivery',
          desc: 'Generate localized proposals for overseas clients in minutes',
        },
        {
          title: 'Cross-Client Reuse',
          desc: 'Reapply industry-specific proposals with prompt-based tweaks',
        },
      ],
      effect: [
        {
          data: [
            {
              label: 'Dimension',
            },
            {
              label: 'Production Time',
            },
            {
              label: 'Multilingual',
            },
            {
              label: 'Knowledge Reuse',
            },
          ]
        },
        {
          data: [
            {
              label: 'Traditional Research',
            },
            {
              label: '10+ hours',
            },
            {
              label: 'Weeks',
            },
            {
              label: 'Difficult',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI Mode',
            },
            {
              label: '10-30 min<br/>(1 min for tuning)',
            },
            {
              label: 'Minutes',
            },
            {
              label: 'Easy',
            },
          ]
        },
      ],
      footerText: 'Start Free Trial',
    },
    // 痛点挖掘
    painPoints: {
      banner: {
        title: 'Pain Points Discovery Expert',
        content: `Equip Every Salesperson with Expert-<br><span style="color: #1A64FE">Level Pain Point Identification</span>`,
      },
      title1: 'Xpirory Pain Points Discovery Expert',
      desc1: 'Converts expert knowledge into reusable diagnostic tools with natural language search for client issues.',
      title2: 'Pain Points Optimization Framework delivers 300%-500% efficiency gain in high-value pain point discovery.',
      platform: {
        list: [
          {
            title: `Multi-Industry Templates`,
            desc: 'Pre-built industry/scenario frameworks',
          },
          {
            title: `Structured Pain Point Library`,
            desc: 'Catalogs high-ROI pain points',
          },
          {
            title: `Best Practice Matching`,
            desc: 'Links proven solutions to each pain point for precise need identification',
          },
          {
            title: `Conversational AI Search`,
            desc: 'Natural language queries for instant solutions',
          },
        ],
      },
      title3: 'Xpirory Unique Advantages',
      title4: 'Use Cases',
      title5: 'Performance Comparison',
      advantage: [
        {
          title: 'Expert Logic Standardization',
          desc: 'Codifies diagnostic methodologies',
        },
        {
          title: 'Precision Search',
          desc: 'Matches colloquial queries to solutions',
        },
        {
          title: 'Precision Natural Language Search',
          desc: 'Matches colloquial queries to solutions in seconds, bridging knowledge gaps',
        },
      ],
      scene: [
        {
          title: 'Existing Client Upselling',
          desc: 'Diagnose new pains via AI search',
        },
        {
          title: 'New Client Scoping',
          desc: 'Comprehensive discovery via guided framework to accelerate projects',
        },
        {
          title: 'Partner Enablement',
          desc: 'Equip partners with OEM-level diagnostic skills',
        },
      ],
      effect: [
        {
          data: [
            {
              label: 'Dimension',
            },
            {
              label: 'Pains Identified',
            },
            {
              label: 'High-Value Pain Detection Rate',
            },
            {
              label: 'Solution Match Accuracy',
            },
            {
              label: 'Training Cycle',
            },
          ]
        },
        {
          data: [
            {
              label: 'Traditional Research',
            },
            {
              label: '1-2 per meeting',
            },
            {
              label: 'Low',
            },
            {
              label: 'Low',
            },
            {
              label: 'Long',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI Mode',
            },
            {
              label: 'Full spectrum',
            },
            {
              label: 'High',
            },
            {
              label: 'High',
            },
            {
              label: 'Short',
            },
          ]
        },
      ],
    },
    // 运营模拟分析平台
    simulation: {
      banner: {
        title: 'Operation Simulation and Analysis Platform',
        content: `Make solution impact visible<br><span style="color: #1A64FE">reduce decision cycle by 60%</span>`,
        desc: 'Visual simulation + quantitative comparison to quickly identify improvements',
      },
      title1: 'Xpirory Operation Simulation and Analysis Platform',
      desc1: 'Upload customer site maps and resource data to generate a visual simulation. AI diagnoses issues and recommends optimizations. Quantitative comparison of multiple scenarios aids project approval decisions.',
      title2: 'AI Lean Improvement Advisor, Simulates operational trends and multiplies efficiency of improvement value assessment',
      platform: {
        list: [
          {
            title: `Easy Resource Modeling`,
            desc: 'Build resource behavior models for multi-dimensional operational analysis',
          },
          {
            title: `Visual Operation Simulation`,
            desc: 'Dynamically simulates resource operations, displaying key metrics',
          },
          {
            title: `AI Analysis & Recommendations`,
            desc: 'AI identifies pain points and quantifies potential improvement effects, reducing investment risks',
          },
          {
            title: `Quantitative Scenario Comparison`,
            desc: 'Compare quantified metrics of different plans for effective decision-making, shortening project approval time',
          },
        ],
      },
      title3: 'Xpirory Unique Advantages',
      title4: 'Use Cases',
      title5: 'Performance Comparison',
      advantage: [
        {
          title: 'Lean Expert Knowledge',
          desc: 'AI applies lean expert experience to every customer',
        },
        {
          title: 'Multi-Scenario Visual Comparison',
          desc: 'Compare optimization plans with clear charts for faster decisions',
        },
        {
          title: 'Quantitative Effect Preview',
          desc: 'Simulate post-optimization data to accelerate project approval',
        },
      ],
      scene: [
        {
          title: 'Operational Bottleneck Diagnosis',
          desc: 'AI quickly analyzes bottlenecks and suggests solutions',
        },
        {
          title: 'Improvement Effect Preview',
          desc: 'Visualize outcomes to clarify ROI expectations',
        },
        {
          title: 'Multi-Scenario Decision Support',
          desc: 'Compare options to expedite project approval',
        },
      ],
      effect: [
        {
          data: [
            {
              label: 'Dimension',
            },
            {
              label: 'Diagnosis Time',
            },
            {
              label: 'Optimization Plan',
            },
            {
              label: 'Decision Cycle',
            },
          ]
        },
        {
          data: [
            {
              label: 'Traditional Mode',
            },
            {
              label: 'Long<br/>(Days)',
            },
            {
              label: 'Qualitative',
            },
            {
              label: '~60 Days<br/>(On-site verification)',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI Mode',
            },
            {
              label: 'Short<br/>(Minutes)',
            },
            {
              label: 'Quantitative',
            },
            {
              label: '~15 Days<br/>(Simulation Data)',
            },
          ]
        },
      ],
    },
    // 远程实景Demo及培训平台
    training: {
      banner: {
        title: 'Demo & Training Platform',
        content: `Immersive demo experience<br><span style="color: #1A64FE">cost reduced by 90%+</span>`,
        desc: 'Multi-camera interaction + remote operation slashes demo costs',
      },
      title1: 'Xpirory Demo & Training Platform',
      desc1: 'Remote multi-camera control allows global clients to view equipment details online, with interactive operation for deeper understanding, reducing travel and demo costs.',
      title2: 'Remote Demo:​ Breaks venue/equipment limits, cuts cost by 90%',
      platform: {
        list: [
          {
            title: `Flexible Site Selection`,
            desc: 'Rich real-world scenes, no installation needed',
          },
          {
            title: `Resource Empowerment Display`,
            desc: 'Visually demonstrate how resources are empowered',
          },
          {
            title: `Configurable Parameters`,
            desc: 'Adjust equipment settings for comprehensive understanding',
          },
          {
            title: `Real-Scene Operation`,
            desc: 'Multi-camera immersion for realistic control experience',
          },
          {
            title: `Open Integration`,
            desc: 'Connect with own systems for integrated demos',
          },
        ],
      },
      title3: 'Xpirory Unique Advantages',
      title4: 'Use Cases',
      title5: 'Performance Comparison',
      advantage: [
        {
          title: 'Interactive Experience',
          desc: 'Clients operate equipment online, unlike static videos',
        },
        {
          title: 'Multi-Angle Detail View',
          desc: 'Switch camera views to see details clearly',
        },
        {
          title: 'Global Lightweight Demo',
          desc: 'Online access for global clients, eliminating travel and shipping costs',
        },
      ],
      scene: [
        {
          title: 'Solution Effect Demo',
          desc: 'Remote demo of custom solutions for project promotion',
        },
        {
          title: 'International Product Training',
          desc: 'Low-cost remote training for partners',
        },
        {
          title: 'Solution Marketing Live Stream',
          desc: 'Accelerate market education',
        },
      ],
      effect: [
        {
          data: [
            {
              label: 'Dimension',
            },
            {
              label: 'Demo Cost',
            },
            {
              label: 'Client Engagement',
            },
            {
              label: 'Solution Understanding',
            },
            {
              label: 'Demo Reach',
            },
          ]
        },
        {
          data: [
            {
              label: 'Traditional Mode',
            },
            {
              label: 'High<br/>(Travel, Shipping, Setup)',
            },
            {
              label: 'Low',
            },
            {
              label: 'Difficult',
            },
            {
              label: 'Limited<br/>(1 Client On-site)',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI Mode',
            },
            {
              label: 'Low<br/>(Network Only, -90%)',
            },
            {
              label: 'High',
            },
            {
              label: 'Easy',
            },
            {
              label: 'Unlimited<br/>(Global Online)',
            },
          ]
        },
      ],
    },
    // 市场分析
    marketAnalytics: {
      banner: {
        title: 'Market Analytics',
        content: `AI Market Analytics - <br><span style="color: #1A64FE">Generate Multi-Lingual Market Reports</span><br>in 5-10 Minutes`,
      },
      title1: 'Xpirory Market Analytics',
      desc1: 'Xpirory Market Analytics captures local-language insights globally, analyzing market maturity, saturation, business fit, policy compliance, cultural compatibility, competitor landscape, and financial risks. Empowers market entry decisions for global expansion.',
      title2: 'Pinpoint target markets,Reduce risks by 80%, slashing 95% research time',
      platform: {
        list: [
          {
            title: `Data Radar`,
            desc: 'Integrates industry trends, pain points, supply chains, competitive differentiation & regulatory landscapes',
          },
          {
            title: `Market Navigation`,
            desc: 'Analyzes entry strategies, positioning & operational tactics',
          },
          {
            title: `Risk Assessment`,
            desc: 'Evaluates political/financial/regulatory risks & exit strategies',
          },
        ],
      },
      title3: 'Xpirory Unique Advantages',
      title4: 'Use Cases',
      title5: 'Performance Comparison',
      advantage: [
        {
          title: 'AI-Powered Strategy',
          desc: 'Delivers actionable entry recommendations with traceable data sources',
        },
        {
          title: 'Real-Time Multi-Lingual Capture',
          desc: 'Eliminates language barriers in policy/news/competitor tracking',
        },
        {
          title: 'Minute-Level Response',
          desc: 'Automates research cycles, 90% faster than traditional methods',
        },
      ],
      scene: [
        {
          title: 'New Market Entry Analysis',
          desc: 'Quickly assess business fit and entry barriers for new markets.',
        },
        {
          title: 'Investment Risk Assessment',
          desc: 'Evaluate financial/policy/environmental risks before investment.',
        },
        {
          title: 'Competitive Landscape Analysis',
          desc: 'Identify competitors’ strategies and weaknesses in target markets.',
        },
      ],
      effect: [
        {
          data: [
            {
              label: 'Dimension',
            },
            {
              label: 'Research Cycle',
            },
            {
              label: 'Team Size',
            },
            {
              label: 'Data Coverage',
            },
          ]
        },
        {
          data: [
            {
              label: 'Traditional Research',
            },
            {
              label: '3-4 weeks',
            },
            {
              label: '5 members',
            },
            {
              label: '30% effective data',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI Mode',
            },
            {
              label: 'Minutes',
            },
            {
              label: '1 operator',
            },
            {
              label: 'Full online data',
            },
          ]
        },
      ],
      footerText: 'Generate Your First Report',
    },
    // 全球获客
    globalCustomer: {
      banner: {
        title: 'Global Lead Gen',
        content: `Instantly Access <span style="color: #1A64FE">High-Value Prospects & Decision Makers</span>`,
      },
      title1: 'Xpirory Global Lead Gen',
      desc1: 'Xpirory identifies target clients & VP-level buyers via multi-dimensional search, AI analysis, and supply chain mapping. Includes company profiles, transaction history & contacts.',
      title2: 'Global Client Radar:300%-500% Efficiency Boost',
      platform: {
        list: [
          {
            title: `Multi-Filter Search`,
            desc: 'Find prospects by buyer/supplier/keyword',
          },
          {
            title: `Supply Chain Mapping`,
            desc: 'Uncover 360° business relationships',
          },
          {
            title: `Competitor Client Tracing`,
            desc: `Track rivals' customers`,
          },
        ],
      },
      title3: 'Xpirory Unique Advantages',
      title4: 'Use Cases',
      title5: 'Performance Comparison',
      advantage: [
        {
          title: 'Multi-Source B2B Database',
          desc: 'Customs data, social & commercial intelligence',
        },
        {
          title: 'AI Matching Engine',
          desc: 'Automates targeted lead discovery',
        },
        {
          title: 'Enterprise Service Insights',
          desc: 'Detects non-standard business needs',
        },
      ],
      scene: [
        {
          title: 'Target Client Acquisition',
          desc: 'Automation solution providers entering Mexico market rapidly matching service-compatible targets',
        },
        {
          title: 'Competitor Client Penetration',
          desc: 'Uncover competitors’ partners to identify pain points and entry strategies',
        },
        {
          title: 'Partnership Development',
          desc: 'Discover complementary suppliers to jointly develop end-users for win-win partnerships',
        },
      ],
      effect: [
        {
          data: [
            {
              label: 'Dimension',
            },
            {
              label: 'Lead Screening Cycle',
            },
            {
              label: 'Decision-Maker Reach Rate',
            },
            {
              label: 'Acquisition Cost',
            },
          ]
        },
        {
          data: [
            {
              label: 'Traditional Mode',
            },
            {
              label: '2 weeks (3 FTEs)',
            },
            {
              label: '15%',
            },
            {
              label: 'High (events/travel)',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI Mode',
            },
            {
              label: '10 minutes',
            },
            {
              label: '>80% (VP level)',
            },
            {
              label: '1/5 traditional cost',
            },
          ]
        },
      ],
    },
    // 客户洞察
    customerInsights: {
      banner: {
        title: 'Customer Insights',
        content: `Decode Overseas Clients with <br/> <span style="color: #1A64FE">85% Higher Match Accuracy</span>`,
      },
      title1: 'Xpirory Customer Insights',
      desc1: 'Analyzes clients’ operations, procurement history & decision chains to deliver tailored engagement strategies.',
      title2: 'Deep Client Intelligence:50%-80% Higher Deal Success',
      platform: {
        list: [
          {
            title: `Pain Point Scanning`,
            desc: 'Identifies industry-specific pain points and collaboration opportunities through holistic data analysis',
          },
          {
            title: `Engagement Strategy Builder`,
            desc: 'Generates data-driven engagement strategies based on mutual capabilities',
          },
          {
            title: `Partnership Risk Evaluation`,
            desc: `Evaluates competitive and collaboration risks using market and competitor intelligence`,
          },
        ],
      },
      title3: 'Xpirory Unique Advantages',
      title4: 'Use Cases',
      title5: 'Performance Comparison',
      advantage: [
        {
          title: 'Deep Needs Matching',
          desc: 'Analyzes "how your solution solves client pains" with entry path guidance – beyond basic profiling',
        },
        {
          title: 'Cross-Cultural Decoding',
          desc: 'Reveals hidden needs based on local business customs to prevent cultural missteps',
        },
        {
          title: 'Proactive Risk Screening',
          desc: 'Flags policy shifts and decision-chain changes in clients’ regions',
        },
      ],
      scene: [
        {
          title: 'Decode Procurement Preferences',
          desc: 'Adjust proposals based on prospects’ purchasing behavior',
        },
        {
          title: 'Partnership Risk Mitigation',
          desc: 'Pre-screen risks and develop countermeasures',
        },
        {
          title: 'Competitive Differentiation',
          desc: 'Design tailored messaging using clients’ pain points with rivals',
        },
      ],
      effect: [
        {
          data: [
            {
              label: 'Dimension',
            },
            {
              label: 'Research Time/Client',
            },
            {
              label: 'Needs Match Accuracy',
            },
            {
              label: 'Sales Cycle',
            },
            {
              label: 'Partnership Risk Screening',
            },
          ]
        },
        {
          data: [
            {
              label: 'Traditional Mode',
            },
            {
              label: '1 week (2 FTEs)',
            },
            {
              label: '40%',
            },
            {
              label: '3+ meetings',
            },
            {
              label: 'No systematic analysis, reliant on manual experience',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI Mode',
            },
            {
              label: '1 hr/10 clients',
            },
            {
              label: '>85%',
            },
            {
              label: '1st-meeting close',
            },
            {
              label: '90% of high-risk clients pre-identified',
            },
          ]
        },
      ],
    },
    // 图文海报制作
    smartPoster: {
      banner: {
        title: 'Smart Poster Generator',
        content: `Create Multi-Lingual Posters in 10 Min<br/> <span style="color: #1A64FE">80%+ Efficiency Gain</span>`,
      },
      title1: 'Xpirory Smart Poster Generator',
      desc1: 'Generates multi-lingual marketing copy using your business knowledge, and auto-produces brand-compliant posters from uploaded templates.',
      title2: 'Streamline marketing material creation with 80% lower costs',
      platform: {
        list: [
          {
            title: `One-Click Design​`,
            desc: 'One-click professional visuals for industries/scenarios with guided workflows',
          },
          {
            title: `Brand Template Control`,
            desc: 'No design skills needed: Generate brand-compliant multi-lingual posters using your knowledge base',
          },
          {
            title: `Sales Material Library`,
            desc: `Centralized library of reusable sales materials for AI`,
          },
        ],
      },
      title3: 'Xpirory Unique Advantages',
      title4: 'Use Cases',
      title5: 'Performance Comparison',
      advantage: [
        {
          title: 'Business-Accurate Copy',
          desc: 'AI interprets technical content for precise messaging',
        },
        {
          title: 'Strict Brand Adherence',
          desc: 'Full control over VI templates (logo/colors/fonts)',
        },
        {
          title: 'Zero-Copyright Risk',
          desc: 'AI-generated images replace stock photos',
        },
      ],
      scene: [
        {
          title: 'Multi-Lingual Campaigns',
          desc: 'Generate market-specific posters in local languages',
        },
        {
          title: 'Localized Social Content',
          desc: 'Create platform-optimized visuals for global social media',
        },
        {
          title: 'Personalized Marketing',
          desc: 'Auto-generate client-specific promotional materials',
        },
      ],
      effect: [
        {
          data: [
            {
              label: 'Dimension',
            },
            {
              label: 'Production Time',
            },
            {
              label: 'Multi-Lingual QA',
            },
            {
              label: 'Copyright Risk',
            },
            {
              label: 'Brand Consistency',
            },
          ]
        },
        {
          data: [
            {
              label: 'Traditional Mode',
            },
            {
              label: '5-8 hours',
            },
            {
              label: 'Error-prone',
            },
            {
              label: 'High',
            },
            {
              label: 'Low',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI Mode',
            },
            {
              label: '10 minutes',
            },
            {
              label: 'AI precision',
            },
            {
              label: 'Zero',
            },
            {
              label: 'High',
            },
          ]
        },
      ],
    },
    // 语音同传及策略沟通助手
    speechTranslator: {
      banner: {
        title: 'Speech Translator',
        content: `<span class="with-dot">Low-Latency Translation</span><br/><span class="with-dot">Real-Time AI Strategy Tips</span>`,
      },
      title1: 'Xpirory Speech Translator',
      desc1: 'Solves "expertise vs. language barrier" in global meetings via <300ms translation, real-time tactics, term decoding, and auto-summaries.',
      title2: 'AI-powered voice communication for dramatically improved efficiency',
      platform: {
        list: [
          {
            title: `<300ms Speech Translation`,
            desc: 'Speak naturally – counterparts hear fluent translations without original audio',
          },
          {
            title: `Real-Time Tactics`,
            desc: 'Instantly suggests responses to challenges (e.g., objections)',
          },
          {
            title: `Term Intelligence`,
            desc: `Auto-detects & explains industry jargon`,
          },
          {
            title: `1-Click Meeting Summary`,
            desc: `Auto-generates key points and action plans`,
          },
          {
            title: `Stealth Mode`,
            desc: `Invisible floating window during screen sharing`,
          },
        ],
      },
      title3: 'Xpirory Unique Advantages',
      title4: 'Use Cases',
      title5: 'Performance Comparison',
      advantage: [
        {
          title: 'True Simultaneous Interpretation',
          desc: 'Translates while speaking (no full-sentence wait)',
        },
        {
          title: 'Zero Installation & Voice Cloning',
          desc: 'Counterparts hear your voice clone in their language',
        },
        {
          title: 'Beyond Translation',
          desc: 'Combines language conversion with tactical guidance to empower professionals',
        },
        {
          title: 'Contextual Term Decoding',
          desc: 'Prevents misunderstandings',
        },
      ],
      scene: {
        type1: 'International',
        type2: 'Domestic',
        typeData1: [
          {
            title: 'Client negotiations',
          },
          {
            title: 'Deal discussions',
          },
          {
            title: 'Overseas strategy <br /> support',
          },
          {
            title: 'Global team <br /> collaboration',
          },
          {
            title: 'Recruitment',
          },
          {
            title: 'Overseas partner <br /> development​',
          },
        ],
        typeData2: [
          {
            title: 'Local client <br /> communication​',
          },
          {
            title: 'Local business <br /> negotiations',
          },
          {
            title: 'Local supplier <br /> engagement​',
          },
          {
            title: 'Domestic partner <br /> development​',
          },
          {
            title: 'Local communication <br /> strategy support​',
          },
          {
            title: 'Local recruitment <br /> support​',
          },
        ],
      },
      effect: [
        {
          data: [
            {
              label: 'Dimension',
            },
            {
              label: 'Translation Lag',
            },
            {
              label: 'Counterpart Distraction',
            },
            {
              label: 'Term Accuracy',
            },
            {
              label: 'Challenge Response',
            },
            {
              label: 'Summary Time',
            },
          ]
        },
        {
          data: [
            {
              label: 'Human Translator',
            },
            {
              label: 'High latency',
            },
            {
              label: 'High',
            },
            {
              label: '60%',
            },
            {
              label: 'Slow (reliant on skill)',
            },
            {
              label: '2 hrs per meeting',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI Mode',
            },
            {
              label: '<300ms',
            },
            {
              label: 'None (Stealth Mode)',
            },
            {
              label: '85%+',
            },
            {
              label: 'Fast (real-time AI)',
            },
            {
              label: '30 seconds',
            },
          ]
        },
      ],
    },
    // 智能邮件
    smartEmail: {
      banner: {
        title: 'Strategic Email Composer',
        content: ` AI-Powered Multilingual Emails with Tactical Guidance & Local Etiquette,<br/> <span style="color: #1A64FE">60%+ Reply Rate Boost</span>`,
      },
      title1: 'Xpirory Strategic Email Composer',
      desc1: 'Generates culturally-adapted multilingual emails with personalized strategies for enterprise services and custom solutions, solving "low reply rates of templated emails and cultural misunderstandings".',
      title2: 'Smart emails enable barrier-free communication with AI-driven efficiency boost',
      platform: {
        list: [
          {
            title: `Contextual Email Drafting`,
            desc: 'Auto-generates stage-specific messaging and guidance',
          },
          {
            title: `Culturally-Optimized Translation`,
            desc: 'Embeds local business etiquette beyond literal translation',
          },
          {
            title: `Template Library`,
            desc: `Pre-built reusable templates`,
          },
        ],
      },
      title3: 'Xpirory Unique Advantages',
      title4: 'Use Cases',
      title5: 'Performance Comparison',
      advantage: [
        {
          title: 'Beyond Templates',
          desc: 'Fully personalized content based on deal stage/client profile',
        },
        {
          title: 'Local Logic Integration',
          desc: 'Translates with cultural business norms',
        },
        {
          title: 'Success Playbook',
          desc: 'Archives & reuses winning messages',
        },
      ],
      scene: [
        {
          title: 'New Prospect Outreach',
          desc: 'Break the ice with culture-optimized emails',
        },
        {
          title: 'Requirement Follow-up',
          desc: 'Respond to client queries strategically',
        },
        {
          title: 'Negotiation Breakthrough',
          desc: 'Counter pressure/challenges with AI tactics',
        },
        {
          title: 'Objection Handling',
          desc: 'Resolve price/solution ambiguities with AI-generated scripts to unblock deals',
        },
      ],
      effect: [
        {
          data: [
            {
              label: 'Dimension',
            },
            {
              label: 'Reply Rate',
            },
            {
              label: 'Translation',
            },
            {
              label: 'Cultural Errors',
            },
            {
              label: 'Communication Cycle',
            },
          ]
        },
        {
          data: [
            {
              label: 'Traditional Mode',
            },
            {
              label: 'Low',
            },
            {
              label: 'High cost',
            },
            {
              label: 'High',
            },
            {
              label: 'Long',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI Mode',
            },
            {
              label: '60%+ higher',
            },
            {
              label: '90% cost reduction',
            },
            {
              label: 'Low',
            },
            {
              label: 'Short',
            },
          ]
        },
      ],
    },
    // 困境策略大师
    strategyCoach: {
      banner: {
        title: 'Sales Strategy Coach',
        content: `Overcome Global Sales Deadlocks with Stage-Specific Tactics,<br/> <span style="color: #1A64FE">>70% Success Rate</span>`,
      },
      title1: 'Xpirory Sales Strategy Coach',
      desc1: 'Generates customized strategies and verbatim scripts for all sales stages (ice-breaking/competitor comparison/price negotiation), adapting to local business cultures to break deadlocks.',
      title2: 'Sales Strategy Coach boosts client success rates by 50%-80%',
      platform: {
        list: [
          {
            title: `Sales Challenge Library`,
            desc: 'Categorized by sales stage for quick reference',
          },
          {
            title: `Tactical Script Generator`,
            desc: 'Auto-creates response strategies for challenges',
          },
          {
            title: `Custom Playbooks`,
            desc: `Tailors guidance using your company/client data`,
          },
        ],
      },
      title3: 'Xpirory Unique Advantages',
      title4: 'Use Cases',
      title5: 'Performance Comparison',
      advantage: [
        {
          title: 'Built for Complex B2B',
          desc: 'Solves pain points of enterprise services/custom solutions – long decision chains, multi-stage communication',
        },
        {
          title: 'Dual Output',
          desc: '"How-to" strategy frameworks + "What-to-say" verbatim scripts',
        },
        {
          title: 'Cross-Cultural Adaptation',
          desc: 'Localizes negotiation language to prevent domestic-tactic failures',
        },
      ],
      scene: [
        {
          title: 'Vague Requirements',
          desc: 'Uncover hidden needs via multi-angle analysis',
        },
        {
          title: 'Competitor Pressure',
          desc: 'Counter with "differentiated value" scripts',
        },
        {
          title: 'Price Negotiation',
          desc: 'Break deadlocks with concession strategies',
        },
      ],
      effect: [
        {
          data: [
            {
              label: 'Dimension',
            },
            {
              label: 'Response Time',
            },
            {
              label: 'Success Rate',
            },
            {
              label: 'Negotiation Cycle',
            },
            {
              label: 'Profit Retention',
            },
          ]
        },
        {
          data: [
            {
              label: 'Traditional Mode',
            },
            {
              label: '2-3 days',
            },
            {
              label: 'Low',
            },
            {
              label: 'Long',
            },
            {
              label: 'Low',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI Mode',
            },
            {
              label: '1 minute',
            },
            {
              label: 'High',
            },
            {
              label: 'Short',
            },
            {
              label: 'High',
            },
          ]
        },
      ],
    },
    // 邮件策略助手
    emailStrategy: {
      banner: {
        title: '邮件策略助手',
        content: `客户开发阶段，<span style="color: #1A64FE">个性化开发策略</span>指导<br>及<span style="color: #1A64FE">沟通话术</span>生成，沟通成功率提高<span style="color: #1A64FE">50%-80%</span>`,
      },
      title1: 'Xpirory 邮件策略助手',
      desc1: '针对企业客户(To B)全球业务开拓阶段，生成定制化邮件策略指导及沟通话术生成，结合跨文化商务习惯，打破沟通僵局。',
      title2: '邮件策略助手，客户沟通成功率提高50%-80%',
      platform: {
        list: [
          {
            title: `客户开发难题库`,
            desc: '客户开发不同阶段的各类难题，快速找到参考',
          },
          {
            title: `AI销售专家`,
            desc: '针对获客场景自动生成回复内容、方法和建议',
          },
          {
            title: `个性化指导`,
            desc: '深度结合企业信息和客户信息，定制企业专属的指导意见',
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '聚焦ToB非标品业务',
          desc: '针对企业服务及非标定品业务决策链长，沟通环节多等业务痛点，提供不同阶段个性化的销售策略',
        },
        {
          title: '策略 + 话术双输出',
          desc: '不仅告诉你 “怎么做”，更告诉你“怎么说”',
        },
        {
          title: '跨文化谈判适配',
          desc: '结合目标市场习惯，优化语言策略，避免 “照搬国内经验” 导致的沟通失效',
        },
      ],
      scene: [
        {
          title: '需求模糊破局',
          desc: '深度分析客户多方面潜在需求，助力多维度主动出击',
        },
        {
          title: '竞品挑战攻坚',
          desc: '客户拿竞品压价：生成 “差异化价值拆解” 话术',
        },
        {
          title: '价格谈判拉锯',
          desc: '客户反复压价，针对性地提供破局谈判策略',
        },
      ],
      effect: [
        {
          data: [
            {
              label: '维度',
            },
            {
              label: '困境响应时间',
            },
            {
              label: '破局成功率',
            },
            {
              label: '谈判周期',
            },
            {
              label: '利润保留率',
            },
          ]
        },
        {
          data: [
            {
              label: '传统人工模式',
            },
            {
              label: '2-3 天 <br/>（团队讨论 + 经验复盘）',
            },
            {
              label: '低',
            },
            {
              label: '长',
            },
            {
              label: '低',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI模式',
            },
            {
              label: `1分钟<br/>（AI 实时生成应对策略）`,
            },
            {
              label: '高',
            },
            {
              label: '短',
            },
            {
              label: '高',
            },
          ]
        },
      ],
    },
    // AI PPT 智能翻译
    aiTranslation: {
      banner: {
        title: 'AI PPT 智能翻译',
        content: `专为企业出海与跨境演示打造，<br>一键完成PPT翻译。`,
      },
      title1: 'Xpirory AI PPT 智能翻译',
      desc1: '聚焦演示文稿翻译+专业表达+版式保真三重需求，一站式解决PPT翻译慢、排版乱、术语不准等痛点，让出海演示、国际汇报、资料交付更高效、更专业。',
      title2: '多语翻译·格式无损·专业高效',
      platform: {
        list: [
          {
            title: `适配日常PPT文档格式`,
            desc: '轻松应对日常PPT文档翻译工作',
            list: [
              {
                label: '· 支持PPTX格式文档翻译',
              },
              {
                label: '· 支持多文件上传，批量翻译',
              },
              {
                label: '· 无需转换格式，上传即识别，不丢页',
              },
            ]
          },
          {
            title: `多语种覆盖`,
            desc: '覆盖主流商务语种，一份 PPT轻松走向全球',
            list: [
              {
                label: '· 支持中/英/日/韩/法/德等多语种互译',
              },
              {
                label: '· 智能选择源语言，一键切换目标语言',
              },
              {
                label: '· 满足海外客户汇报、方案交付、全球培训等场景',
              },
            ]
          },
          {
            title: `自定义术语`,
            desc: '企业专属术语库，译文更地道、更专业',
            list: [
              {
                label: '· 支持自建行业术语库',
              },
              {
                label: '· 固定专业译法，避免歧义，统一品牌表达',
              },
              {
                label: '· 翻译自动匹配术语，准确率大幅提升',
              },
            ]
          },
          {
            title: `自动适配原文排版`,
            desc: '翻译后版式自动适配，无需重新排版',
            list: [
              {
                label: '· 自动适配文本框',
              },
              {
                label: '· SmartArt、表格、标题层级完整保留',
              },
              {
                label: '· 导出即用',
              },
            ]
          },
        ],
      },
      title3: 'Xpirory 差异化优势',
      title4: '应用场景',
      title5: '应用效果',
      advantage: [
        {
          title: '从 “排版混乱”到<br/> “版式保真”',
          desc: '区别于普通工具翻译后排版全乱，Xpirory 实现翻译后格式自动适配。',
        },
        {
          title: '从 “通用翻译”到<br/> “行业精准”',
          desc: '融合自定义术语+AI上下文理解，内容表达更精准。',
        },
        {
          title: '从 “单文件低效”到<br/> “批量高效”',
          desc: '支持更多页面批量翻译，企业办公更省时。',
        },
      ],
      scene: {
        type1: '国际商务',
        type2: '国内协同',
        typeData1: [
          {
            title: '海外客户提案',
          },
          {
            title: '海外培训课件',
          },
          {
            title: '国际商务宣讲',
          },
          {
            title: '全球产品发布',
          },
        ],
        typeData2: [
          {
            title: '跨区域团队汇报',
          },
          {
            title: '对外宣传材料',
          },
          {
            title: '多语言内部培训',
          },
          {
            title: '会议演示文稿',
          },
        ],
      },
      effect: [
        {
          data: [
            {
              label: '对比维度',
            },
            {
              label: '排版完整性',
            },
            {
              label: '翻译速度',
            },
            {
              label: '术语准确率',
            },
            {
              label: '人力成本',
            },
            {
              label: '翻译质量',
            },
          ]
        },
        {
          data: [
            {
              label: '其他PPT翻译工具',
            },
            {
              label: '易错乱、需重排',
            },
            {
              label: '慢、耗时长',
            },
            {
              label: '术语翻译随机，无法指定',
            },
            {
              label: '高(校对+ 排版)',
            },
            {
              label: '机器直译',
            },
          ]
        },
        {
          data: [
            {
              label: 'Xpirory AI PPT 翻译',
            },
            {
              label: `高度还原排版格式`,
            },
            {
              label: '高效、快速翻译',
            },
            {
              label: '自定义术语表+ AI精准理解',
            },
            {
              label: '低，一键完成',
            },
            {
              label: 'AI翻译',
            },
          ]
        },
      ],
    },
    // 隐私政策
    policy: {
      date: 'Effective Date: April 7, 2025',
      msg: 'Introduction',
      msg1: 'Xpirory is an online service platform developed and operated by XPIRORY PTE. LTD. (“we” or “us”). When you use our products and services, we may collect and use your relevant information. This Privacy Policy aims to explain how we collect, use, store, and share this information, and how you can access, update, control, and protect it. This policy is closely related to the Xpirory services you use, so please read it carefully and make appropriate choices as needed. Technical terms mentioned in this policy are explained in a concise manner, with links for further clarification if necessary.',
      msg2: 'By using or continuing to use our services, you consent to our collection, use, storage, and sharing of your information as described in this Privacy Policy.',
      msg3: 'If you have any questions about this Privacy Policy or related matters, please contact us at: business development@xpirory.com.',
      msg4: '1. Information We Collect',
      msg5: 'We or our third-party partners may collect, store, and use the following information about you when providing services. If you choose not to provide certain information, you may not be able to register as a user or use specific features, or the intended results may not be achieved.',
      msg6: 'Personal Information: Provided when registering an account or using services, such as your email address, password, username, login credentials, mobile number, SMS verification code, etc.',
      msg7: 'Location Information: When location services are enabled, we collect your geographical data via GPS or Wi-Fi. You can disable location services to stop this data collection.',
      msg8: '',
      msg9: '',
      msg10: 'Camera/Storage Access: Required for image upload/download features. We will only access this data when you grant permission during app use.',
      msg11: 'Device and Connection Info: Includes your IP address, browser type and version, device details, etc.',
      msg12: 'Log Data: Collected through cookies, identifiers, and other technologies, such as browsing activity, click data, and device logs. You can manage these settings via your browser.',
      msg13: 'Content Submission: When using our services to create reports or documents, we collect submitted content such as business descriptions, customer data, map files, behavior simulation data, etc. If your content includes third-party information, you are responsible for obtaining proper authorization.',
      msg14: 'Transaction Data: We use Stripe for payment processing. We collect transaction data reported back by Stripe, including user ID, transaction amount, time, merchant, and status. Device info may also be collected for security.',
      msg15: 'Maintenance and Security Needs: To ensure system security, prevent fraud, bugs, or abuse, we may collect device data, logs, clipboard data, and data from our affiliates or partners with your authorization.',
      msg16: 'Other Information: Usage records generated during browsing, clicking, searching, or viewing within the platform are stored as service logs.If your information is used for purposes not covered in this policy, we will first seek your consent.',
      msg17: '2. Information Storage',
      msg18: '2.1 Storage Methods and Duration',
      msg19: 'We store your information securely through methods like local storage, databases, and server logs. ',
      msg20: 'Generally, data is retained only as long as necessary for service provision or as required by law.',
      msg21: '2.2 Storage Location',
      msg22: 'Personal data collected in Singapore is stored in Singapore. For features like cross-border payments, data may be transmitted via third parties (e.g., Stripe, Google) to the U.S. or EU in accordance with SCCs or equivalent mechanisms.',
      msg23: '2.3 Service Discontinuation',
      msg24: 'If we cease operation of our products or services, we will notify you through announcements or push notifications and delete or anonymize your data within a reasonable timeframe unless otherwise required by law.',
      msg25: '3. Data Security',
      msg26: 'We use a variety of technologies and procedures to protect your data from loss, misuse, unauthorized access, or disclosure. For example, SSL encryption may be used. However, due to the nature of the internet, no system is completely secure. Please understand that risks may arise from factors beyond our control.',
      msg27: '4. How We Use Information',
      msg28: 'Your data may be used for:',
      msg29: 'Providing services (authentication, customer support, fraud detection, etc.);',
      msg30: 'Sharing with authorized third parties when legally allowed and necessary;',
      msg31: 'Improving or designing new services;',
      msg32: 'Personalizing services (e.g., location settings, language, help content);',
      msg33: 'Showing personalized ads;',
      msg34: 'Evaluating and enhancing promotional activities;',
      msg35: 'Software verification and updates;',
      msg36: 'Conducting surveys.',
      msg37: 'Data Use Purposes and Legal Grounds (GDPR):',
      msg38: 'Purpose',
      msg39: 'Data Type',
      msg40: 'Legal Basis',
      msg41: 'Account management',
      msg42: 'Email, username',
      msg43: 'Contract necessity',
      msg44: 'Payment processing',
      msg45: 'Payment info',
      msg46: 'Contract necessity',
      msg47: 'Service personalization',
      msg48: 'Preferences, location',
      msg49: 'User consent via cookies',
      msg50: 'Security & anti-fraud',
      msg51: 'IP, device info',
      msg52: '',
      msg53: 'Legitimate interests',
      msg54: '5. Information Sharing',
      msg55: 'We do not share your personal data unless necessary for platform functions or required by third-party services:',
      msg56: 'Payment Providers: Stripe, WeChat Pay, Alipay',
      msg57: 'Analytics: Google Analytics (anonymized)',
      msg58: 'Advertising: Google Ads (subject to privacy safeguards)',
      msg59: 'We do not share personally identifiable data (e.g., name, email) with partners unless explicitly authorized by you.',
      msg60: 'We may disclose data if legally required or if public interest or law enforcement is involved.',
      msg61: '',
      msg62: '',
      msg63: '',
      msg64: '',
      msg65: '',
      msg66: '',
      msg67: '',
      msg68: '',
      msg69: '',
      msg70: '6. Your Rights',
      msg71: 'You may query, delete, correct, or withdraw consent for personal data through service settings or by contacting us.',
      msg72: 'If you wish to stop using the service, you may request account deletion. Your data will be deleted or anonymized unless otherwise required by law.',
      msg73: '7. Children’s Privacy',
      msg74: 'We do not knowingly collect data from children under 16. If you discover such data was provided, contact us and we will delete it.',
      msg75: '8. Changes',
      msg76: 'We may revise this policy and notify you upon update. Continued use of our services implies consent to the revised policy.',
    },
    // 使用条款
    useTerms: {
      date: 'Effective Date: April 7, 2025',
      msg1: 'XPIRORY PTE. LTD. (“Xpirory”) has updated the terms of use applicable to our website. For the purposes of these Terms of Use (the “Terms”), the term “Website” refers to the official Xpirory site (www.xpirory.com) and all other Xpirory-operated websites that link to these Terms.',
      msg2: 'We provide access to the Website under these Terms, which may be updated from time to time as described in Section 1 below. By accessing or using the Website, you accept and agree to be bound by these Terms, the Xpirory Privacy Policy, and the Xpirory Cookie Policy. If you do not agree, you should not access or use the Website. In addition, you must comply with any rules or guidelines posted on the Website, which may be updated and incorporated into these Terms.',
      msg3: 'Our practices regarding how we collect, use, and protect any electronic data, text, or other materials you submit and store in the service (“Service Data”) are detailed in the Privacy Policy.',
      msg4: '1. Modifications to Terms',
      msg5: 'We may modify any part of these Terms at any time, including adding or removing terms. Changes take effect immediately upon posting. Your continued use of the Website following such changes indicates your acceptance.',
      msg6: '2. Changes to the Website',
      msg7: 'We reserve the right to modify or discontinue any part of the Website, including content, availability, or required access tools, at any time without notice.',
      msg8: '3. Registration',
      msg9: 'You may create a user account (“Your Account”) to access certain Website features. We will use the information you provide in accordance with our Privacy Policy. By registering, you represent and warrant that your information is true, complete, and accurate, and you agree to keep it up to date. You are responsible for any necessary hardware, software, and costs associated with accessing the Website.',
      msg10: '4. User Content Guidelines',
      msg11: 'The following applies to any content you submit:',
      msg12: '4.1 The Website may offer features such as queries, uploads, or text input. You are solely responsible for all materials you submit or upload (“User Content”), including text, images, and documents. These features are only available to users aged 16 and above. By submitting User Content, you confirm that you are at least 16 years old; users under 18 must obtain parental or guardian consent.',
      msg13: '4.2 You agree not to upload or share any content that:',
      msg14: '(a) Violates others’ rights (e.g., defamation, harassment, threats);',
      msg15: '(b) Is knowingly false, misleading, or inaccurate;',
      msg16: '(c) Includes hate speech, racial or ethnic slurs, vulgarity, or profanity;',
      msg17: '(d) Contains or promotes pornography, explicit sexual content, pedophilia, incest, bestiality, or other obscene material;',
      msg18: '(e) Encourages illegal, dangerous, or exploitative behavior;',
      msg19: '(f) Promotes violence;',
      msg20: '(g) Poses threats to personal or public safety;',
      msg21: '(h) Depicts graphic violence or abuse for exploitative or improper purposes;',
      msg22: '(i) Uses copyrighted, trademarked, or proprietary material without express permission;',
      msg23: '(j) Contains spam, chain letters, or other promotional schemes;',
      msg24: '(k) Misuses real names or likenesses without permission;',
      msg25: '(l) Violates applicable laws and regulations.',
      msg26: 'You are solely liable for any resulting damages. Xpirory reserves the right to block content submissions by violators.',
      msg27: '4.3 You may not imply Xpirory’s endorsement of any User Content.',
      msg28: '4.4 You may not upload files containing viruses or destructive code.',
      msg29: '4.5 We are not responsible for the accuracy of User Content; usage is at your own risk.',
      msg30: '5. User Conduct',
      msg31: 'You agree not to:',
      msg32: '(a) Interfere with the Website’s normal operation or networks;',
      msg33: '(b) Copy, sell, or exploit Website content for commercial purposes;',
      msg34: '(c) Engage in illegal activity;',
      msg35: '(d) Impersonate Xpirory or its employees;',
      msg36: '(e) Violate others’ privacy.',
      msg37: '6. Intellectual Property',
      msg38: 'All content on the Website, including text, graphics, trademarks, and software, is owned by or licensed to Xpirory and is protected under intellectual property laws. Reproduction or distribution of Website content without written consent is prohibited, except for personal, non-commercial use with proper attribution.',
      msg39: '7. Disclaimers and Limitations of Liability',
      msg40: '(A) You use the Website at your own risk. Xpirory does not guarantee uninterrupted or error-free service.',
      msg41: '(B) The Website is provided “as is” with no express or implied warranties, except those required by law.',
      msg42: '(C) To the maximum extent permitted by law, Xpirory is not liable for direct, indirect, incidental, or consequential damages (e.g., data loss or reputational harm) resulting from use of the Website.',
      msg43: '(D) We are not responsible for unauthorized access to your personal information.',
      msg44: '8. Termination and Suspension',
      msg45: 'We may suspend or terminate your access to the Website at any time without notice or liability.',
      msg46: '9. Copyright & DMCA Agent',
      msg47: 'If you believe any content on the Website infringes your copyright, please follow our DMCA Notice and Takedown Policy to file a report.',
      msg48: '10. Digital Services Act (DSA)',
      msg49: 'Under the EU Digital Services Act, to report illegal content, please contact us. EU authorities, national agencies, and the Digital Services Board may contact us at: business development@xpirory.com.',
    },
    // 代运营服务
    services: {
      msg1: 'Agency Operation Services',
      msg2: 'One-stop AI tools for lead generation and conversion — helping you go global easily.',
      msg2_2: 'One-stop AI tools for lead generation and conversion — helping you go global easily.',
      msg3: 'Overseas Lead Generation (Agency Model)',
      msg4: 'Overseas Business Support',
      msg5: 'No dedicated team for overseas market research or client outreach?<br />Leave it to us.',
      msg6: 'New to AI tools or lack support staff?<br />We’ll handle it for you.',
      msg7: 'Service 1',
      msg8: 'Service 2',
      msg9: 'For teams without a dedicated lead generation staff, we provide full-service agency support.',
      msg10: 'We provide the following services:',
      msg11: 'You will receive:',
      msg12: 'Market Analysis',
      msg13: 'Use AI tools to scan, filter and analyze global markets — with insights and strategy advice.',
      msg14: 'Client List Generation',
      msg15: 'Extract verified overseas companies that match your business profile.',
      msg16: 'Client Insight Reports',
      msg17: 'Analyze client background, pain points, and risks for better engagement.',
      msg18: 'Personalized Email Outreach',
      msg19: 'Tailor unique email campaigns for each client — no bulk templates.',
      msg20: 'Agreed number of market analysis reports (size, competition, entry advice).',
      msg21: 'Verified potential client lists with key contacts.',
      msg22: 'Insight reports for key clients — giving your sales team early advantage.',
      msg23: 'Personalized outreach emails sent to target companies on your behalf.',
      msg24: 'Valid inquiries from this service',
      msg25: 'For teams new to AI tools or global operations, this support service helps you start quickly.',
      msg26_1: 'Pain Points Discovery Expert',
      msg26: 'Pain Point Discovery Service',
      msg27: 'Pain Point Platform Data Setup Service',
      msg28: 'Help you analyze client needs and pain points using AI tools (online support).',
      msg29: 'Operation Simulation Analysis Service',
      msg30: 'Operational Simulation & Analysis Setup Service',
      msg31: 'Simulate client operations and analyze in real time (online support).',
      msg32: 'Remote Live Demo Service',
      msg33: 'Demo & Training Platform',
      msg34: 'Remote Demo Scene & Room Setup Service',
      msg35: 'Set up and perform live demos for clients remotely (online support).',
      msg36: 'Complete Platform Tools',
      msg37: 'No need for dedicated technical setup.',
      msg38: 'Remote Consultant Support，Professional consultants accompany your overseas meetings remotely.',
      msg39: 'We provide the following products & services:',
      msg40: 'Consult now',
    },
    // 不懂外语怎么和客户沟通及开会?
    problemCommunicate: {
      msg1: 'How to bridge the language gap?',
      msg2: 'One-stop AI tools for lead generation & deal conversion — helping you expand globally.',
      msg3: 'Current Challenges',
      msg4: `Many companies eager to expand globally are stalled by language barriers.Hiring bilingual staff is time-consuming and costly.Your best salespeople likely don't speak English, limiting direct client engagement.This double-bind often delays or prevents global outreach entirely.`,
      msg5: 'Our Solution',
      msg6: 'Our AI Meeting Assistant lets your current team communicate globally in real-time.',
      msg7: 'Your existing team knows your product best. This tool lets them engage overseas clients immediately, at low cost.Test new markets effectively before committing to hiring.',
      msg8: 'It works with Zoom, Teams, etc. – clients join with one click, hear clear English translation.No setup or training needed for clients.',
      msg9: 'Low-latency translation ensures a natural, fluid conversation.Your team focuses on the discussion, not the language barrier.',
      msg10: 'Use Current Staff',
      msg11: `Leverage your existing team's expertise; no need to hire bilingual staff.`,
      msg12: 'Lower Upfront Cost',
      msg13: 'Avoid the high cost and time of recruiting and training new staff.',
      msg14: 'Zero-Client Setup',
      msg15: 'Works with popular meeting platforms; clients join instantly without any installation.',
      msg16: 'Natural Conversation',
      msg17: 'Low-latency, real-time translation allows for focused business discussions.',
      msg18: 'AI Meeting Assistant',
      msg19: 'Core Features',
      msg20: 'Real-time speech translation',
      msg21: 'Communication strategy suggestions',
      msg22: 'Smart term explanation',
      msg23: 'Benefits',
      msg24: 'Highly compatible, no client-side setup needed',
      msg25: 'Low-latency translation',
      msg26: 'Direct English audio output',
      msg27: 'Problem-solving tools',
    },
    // 出国考察前要思考哪些问题?
    overseasInspection: {
      msg1: 'What to check before going abroad?',
      msg2: 'One-stop AI tools for lead generation & deal conversion — helping you expand globally.',
      msg3: 'Current Challenges',
      msg4: 'Many businesses join overseas tours without prior research, resulting in wasted trips and vague insights.',
      msg5: 'Our Solution',
      msg6: 'Our Advice',
      msg7: '',
      msg8: 'Use our tools for deep market research before expensive trips. Understand: Market maturity and saturation? Market-business fit? Key policies to consider? Cultural and product compatibility? Local competitor landscape? Potential risks to avoid? Focus your trip on validating key findings for efficient decision-making.',
      msg9: 'Market maturity and saturation?',
      msg10: 'Market-business fit?',
      msg11: 'Key policies to consider?',
      msg12: 'Cultural and product compatibility?',
      msg13: 'Local competitor landscape?',
      msg14: 'Potential risks to avoid?',
      msg15: 'Data Radar',
      msg16: 'Market Navigator',
      msg17: 'Risk Assessment',
      msg18: 'Guides you to niche markets',
      msg19: 'Collects data in all languages',
      msg20: 'Reports are 3x more detailed than ChatGPT',
    },
    // 对海外某个客户不了解怎么办?
    customerInform: {
      msg1: 'How to understand an unfamiliar overseas client?',
      msg2: 'One-stop AI tools for lead generation & deal conversion — helping you expand globally.',
      msg3: 'Current Challenges',
      msg4: `A major reason for failed deals overseas is a lack of deep understanding of target clients.Limited by language barriers and information access, teams often rely solely on websites and fragmented public data, leading to incomplete insights that hinder effective engagement.Worse, without systematic analysis of the client's structure, pain points, and competitive landscape, outreach lacks precision, fails to demonstrate expertise, and risks wasted resources due to misjudgment.`,
      msg5: 'Our Solution',
      msg6: 'To address this blind spot, use the Customer Insights tool for deep intelligence early in the sales process.After entering basic client info, the AI-powered tool gathers and integrates multi-language data, generating a comprehensive report covering potential pains, product fit, organizational structure, competitors, and partnership risks.This structured client profile enables precise strategy formulation, preventing misguided outreach even from a distance.',
      msg7: 'Deep Client Insights',
      msg8: 'Transforms fragmented data into a complete profile, boosting research efficiency by 300%.',
      msg9: 'Precise Strategy',
      msg10: 'Personalized outreach based on client pains increases success rates by 50-80%.',
      msg11: 'Proactive Risk Assessment',
      msg12: 'Multi-dimensional risk evaluation enables smarter resource allocation.',
      msg13: 'Overcome Language Barriers',
      msg14: 'Automatically integrates data in all languages, eliminating information gaps.',
      msg15: 'Pain Point Scan',
      msg16: 'Strategy Analysis',
      msg17: 'Risk Assessment',
      msg18: 'Collects data in all languages',
      msg19: 'Deep Product-Client Biz Matching',
      msg20: 'Reports are 3x more detailed than ChatGPT',
    },
    // 国内团队能否做海外市场？
    domesticTeam: {
      msg1: 'Can a local team handle global markets?',
      msg2: `Today, many capable domestic teams struggle to expand globally due to geographic, language, and cultural barriers.The traditional belief is that going global requires building a local team or frequent travel from day one to effectively engage clients.This not only skyrockets labor and travel costs but also causes delays and inefficient communication across time zones.As a result, the team's expertise fails to quickly translate into overseas competitiveness, leading to missed opportunities.`,
      msg3: `Xpirory's AI tools enable your domestic team to efficiently engage global markets from the start.Use Global Customer Acquisition to proactively find and qualify leads, breaking geographical limits.Then, use Customer Insights to analyze client backgrounds and pain points for a quick entry strategy.The AI Meeting Assistant enables real-time, cross-language communication, letting your experts talk directly to clients.This allows you to launch overseas operations even before a new team is fully onboarded.The Email Strategy Assistant auto-generates communications that respect local business etiquette.The Solution Generation Platform quickly produces tailored proposals for international clients.This empowers your local team to take the first step globally with confidence.`,
      msg4: 'Break Geographical Barriers',
      msg5: 'Your domestic team can directly reach and manage overseas clients, reducing reliance on a local team early on.',
      msg6: 'Zero Communication Barriers',
      msg7: 'Real-time speech translation allows seamless meetings with international clients.',
      msg8: 'Agile Response',
      msg9: 'Speed up the entire process from client insight to proposal, cutting the sales cycle by 40%.',
      msg10: 'Optimized Cost Structure',
      msg11: 'Cut initial costs for building an overseas team and frequent travel, reducing labor and operational costs by 60%.',
      msg12: 'Multi-dimensional search',
      msg13: 'Supply chain mapping',
      msg14: 'Competitor analysis',
      msg15: 'Real global transaction data',
      msg16: 'Coverage in 230+ regions',
      msg17: 'Key decision-maker contacts',
      msg18: 'AI Meeting Assistant',
      msg20: 'Sales challenge library',
      msg21: 'AI sales expert',
      msg22: 'Personalized guidance',
      msg24: 'Covers a wide range of sales challenges',
      msg25: 'Intelligently adapts to international business etiquette',
      msg26: 'Provides strategy advice, not just templates',
      msg27: 'Professional content generation',
      msg28: 'Multi-language output',
      msg29: 'Customizable solution templates',
      msg30: 'Supports reference document upload',
      msg31: 'Controllable enterprise template layout',
      msg32: 'Pre-set solution outlines',
    },
    // 客户不搭理你该怎么办？
    customerRespond: {
      msg1: 'What if prospects don’t respond?',
      msg2: 'In global outreach, prospect silence is a common bottleneck. Generic, mass emails often get ignored as spam.The core issue: traditional email campaigns lack true personalization based on industry, business stage, or real pain points.Cross-cultural gaps also reduce professionalism and open rates, causing missed opportunities early on.',
      msg3: 'Solve this with our Email Strategy Assistant and Smart Outreach Email tools for targeted breakthrough.Input prospect details like company size and industry; AI analyzes their needs and identifies relevance to your solution.It then generates highly personalized email content for different scenarios, with multilingual translation and local business etiquette baked in—boosting open and reply rates.',
      msg4: 'Higher Open Rates',
      msg5: 'Dynamic, personalized content boosts open rates by 50-80%.',
      msg6: 'Cross-Cultural Clarity',
      msg7: 'Built-in multilingual translation respects local business norms.',
      msg8: 'Full-Funnel Strategy',
      msg9: 'AI sales expert suggests follow-ups for each stage to re-engage silent prospects.',
      msg10: 'Scale Personalization',
      msg11: 'Generate personalized emails at scale—3x more output per team member.',
      msg12: 'AI-generated email content',
      msg13: 'Multi-language translation',
      msg14: 'Ready-to-use templates',
      msg15: 'One-to-one personalization​',
      msg16: 'Adapts to local etiquette',
      msg17: 'End-to-end strategy guidance',
    },
    // 如何低成本出海?
    lowCost: {
      msg1: 'How to go global with low cost?',
      msg2: 'Companies often face "high-cost trial and error" when going global. Traditional methods rely on offline visits, multilingual teams, and frequent travel, leading to high costs and low efficiency. Information asymmetry causes market miscalculations, while communication barriers prolong sales cycles, resulting in "high input, slow returns."',
      msg3: `For cost-effective expansion, leverage Xpirory's AI tools to reduce costs and boost efficiency across the entire customer acquisition and conversion journey.Use AI Market Analysis to identify the right markets, avoiding wasted efforts.Use Global Customer Acquisition tools to find potential clients proactively, replacing costly offline promotion.Empower your local sales team to communicate directly with overseas clients using the AI Meeting Assistant, reducing the need for expensive multilingual staff.Equip partners quickly with the Pain Points Discovery Expert.Respond to client needs swiftly with the Solution Generation Platform.Finally, replace travel with the Remote Demo & Training Platform for immersive online demos, optimizing costs across the board.`,
      msg4: 'Precise Market Targeting',
      msg5: 'AI analysis reduces guesswork, improving market screening efficiency by 300%.',
      msg6: 'Efficient Global Lead Generation',
      msg7: 'Multi-criteria search quickly generates quality lead lists, boosting efficiency by over 300%.',
      msg8: 'Optimized Labor Costs',
      msg9: 'Using the AI Meeting Assistant cuts initial team setup costs by 50%.',
      msg10: 'Partner Empowerment',
      msg11: 'New team members or partners get up to speed fast, improving needs discovery efficiency by 300%.',
      msg12: 'Agile Proposal Response',
      msg13: 'Automatically generate multilingual proposals, increasing customization efficiency by 500%.',
      msg14: 'Drastically Reduced Demo Costs',
      msg15: 'Remote demos replace travel, cutting demo costs by 90%.',
      msg16: 'Multi-scenario configuration',
      msg17: 'High-ROI pain points library',
      msg18: 'Best solution matching',
      msg20: 'AI-powered search',
      msg21: 'Layered knowledge system',
      msg22: 'Visual scenario display',
      msg23: 'Natural language search',
      msg24: 'Demo & Training Platform',
    },
    // 如何高效联系大量客户?
    customerContact: {
      msg1: 'How to Reach Clients at Scale?',
      msg2: 'Reaching a large volume of clients with personalized communication is a major hurdle in global expansion.Manual outreach is slow, hard to scale, and struggles to maintain quality.Generic bulk emails get ignored, while manual personalization limits volume.The deeper challenge: creating culturally precise content at scale is difficult for non-native speakers.',
      msg3: `Use Global Customer Acquisition and the Email Strategy Assistant for scaled, personalized outreach.First, use Global Customer Acquisition to source targeted lead lists in bulk.Then, the Email Strategy Assistant generates unique, personalized email content for each prospect.With built-in multilingual adaptation, each email respects local business customs and matches the client's context.This enables your team to handle multiple times the outreach volume without sacrificing quality.`,
      msg4: '5x Output',
      msg5: 'Dramatically increase content output and reach, boosting per-person efficiency by 500%.',
      msg6: 'Quality at Scale',
      msg7: 'Get personalized messaging in every email, increasing reply rates by 50-80%.',
      msg8: 'Cultural Precision',
      msg9: 'A built-in library of multinational business etiquette prevents cross-cultural missteps.',
    },
    // 如何找到目标客户？
    targetCustomer: {
      msg1: 'How to find target clients?',
      msg2: 'Early-stage companies often waste time and money using ineffective client acquisition methods without a clear strategy.',
      msg3: 'Our Approach: Start online, then offline. Use our Global Customer Acquisition tool to find real buyers with transaction history and get key contacts. Let your team test markets cheaply, quantify client profiles, and guide further investments like ads or events.',
      msg4: 'Targeted lead lists, not random searching.',
      msg5: '直接从“大海捞针”变为“清单式开发”，精准获取有真实交易记录的潜在客户及其联系方式。',
      msg6: 'Lower costs by optimizing channel spend.',
      msg7: '大幅减少在多种渠道上的盲目投入，优化整体获客预算的分配效率。',
      msg8: 'Data-driven decisions for events or local teams.',
      msg9: '为是否参加某地区展会、是否建立本地团队等决策提供数据支持，避免盲目投入。',
      msg10: ' Find leads in minutes, not months.',
      msg11: '将漫长的客户搜寻过程缩短至几分钟，快速锁定目标，加速销售 pipeline 的构建。',
    },
    // 适合自己的海外市场在哪里?
    overseasMarket: {
      msg1: 'Which global market is right for you?',
      msg2: 'Companies often struggle to identify the right overseas market initially. Relying on limited language sources leads to information gaps, causing risky market entry decisions. The core issue is lacking a tool for multi-dimensional, real-time, localized analysis.',
      msg3: 'Pinpoint the best market-fit quickly.',
      msg4: 'Use our AI Market Analysis tool to turn guesswork into data-driven decisions. Input your business profile and target markets; the tool scans and assesses market conditions, compliance, culture, and competition, delivering a detailed report.',
      msg5: 'Pinpoint the best market-fit quickly.',
      msg6: '',
      msg7: 'Cut research time from weeks to minutes.',
      msg8: '',
      msg9: 'Identify risks early to reduce trial costs.',
      msg10: '',
      msg11: 'Get deep, structured reports for informed decisions.',
      msg12: '',
    },
    // 海外产品演示成本过高怎么办?
    demonstrateCost: {
      msg1: 'What if onsite demos are too costly?',
      msg2: `Onsite demos face three "highs": high travel, time, and shipping costs.Sending teams with equipment leads to very high cost per demo.High costs limit demo opportunities, hurting conversion of quality leads.Sudden policy changes can cancel long-planned demos, wasting resources.`,
      msg3: 'Our Remote Demo Platform enables complete online product demonstration and interaction.Set up your product or solution on the platform.Clients access via a unique link to remotely control real equipment and view it from multiple angles.',
      msg4: 'Remote Control of Real Equipment',
      msg5: 'Clients control actual equipment remotely for an immersive experience.',
      msg6: 'Multi-Angle Observation',
      msg7: 'HD multi-angle views let clients inspect details independently.',
      msg8: 'One-Click Access',
      msg9: 'Clients join instantly via a link—no software installation needed.',
      msg10: 'Save Time & Accelerate Decisions',
      msg11: 'Enable deep product validation without travel, cutting costs and speeding up decisions.',
      msg12: 'Intuitive product/solution demo',
      msg13: 'Flexible integration with your own scenarios',
      msg14: 'Immersive real-scene control',
      msg15: 'Flexible demo scheduling',
      msg16: 'Remote interactive experience',
    },
    // 海外新人或者合作伙伴如何快速掌握业务?
    businessMastery: {
      msg1: 'How to onboard new overseas staff or partners quickly?',
      msg2: 'New overseas team members or partners often face an "experience gap" when starting.Unfamiliar with your products and industry, they struggle to systematically uncover client needs.While experienced consultants can identify needs accurately, their availability is limited.This slows down global expansion, causing valuable opportunities to be lost.The deeper issue is the lack of tools to transform core knowledge into reusable, standardised assets.',
      msg3: `Use the Pain Points Discovery Expert to quickly empower new teams during the conversion stage.The platform's "Business Scenario Map" visually structures high-value pain points and best-practice solutions.Newcomers simply follow the industry and scenario guide to identify all relevant client pain points.The AI-powered search instantly finds solutions to specific client questions.This enables even inexperienced staff to conduct expert-level needs discovery.`,
      msg4: 'Faster Needs Discovery',
      msg5: 'Map pain points to solutions quickly, improving discovery efficiency by 300-500%.',
      msg6: 'Knowledge Empowerment',
      msg7: 'Turn expert knowledge into a reusable system, accelerating newcomer readiness.',
      msg8: 'Accurate Solution Matching',
      msg9: 'Leverage a library of best practices to improve solution fit by over 50%.',
      msg10: 'Optimized Team Collaboration',
      msg11: 'Enable global teams and partners to use the same standardized tool, cutting training costs by 80%.',
    },
    // 客户需求不清晰怎么办？
    unclearDemand: {
      msg1: 'What if client needs are unclear?',
      msg2: `Unclear client needs are a major barrier to converting opportunities in B2B sales.This is especially true for new sales staff or overseas partners who lack structured methodology for needs discovery.While experienced consultants can identify needs quickly, they can't scale to cover all clients, leading to lost opportunities.The core issue is the failure to transform scattered expert knowledge into a reusable system.`,
      msg3: `Address this with our Pain Points Discovery Expert during the conversion stage.Simply select the client's industry and scenario to access a library of common pain points and matching solutions.A visual "Business Scenario Map" intuitively displays potential client challenges.The AI-powered search instantly finds solutions to specific client questions.This enables even inexperienced team members to conduct expert-level needs discovery.`,
    },
    // 如何高效应对多个客户的产品/方案需求?
    efficientResponse: {
      msg1: 'How to handle multiple client requests efficiently?',
      msg2: 'A common challenge in global expansion is handling multiple client requests simultaneously.When sales or pre-sales teams face numerous overseas clients, traditional proposal methods fail to keep up with changing needs.Staff must search through scattered product materials, manually compile documents, create tailored solutions, and spend time on manual translation.This process consumes significant resources. Often, unclear client intent leads to wasted effort, hurting true conversion rates.',
      msg3: 'The Solution Generation Platform enables efficient handling of multiple client needs during the opportunity conversion stage.Simply input core requirements and select relevant documents (product info, case studies, technical docs). The platform intelligently extracts key points and auto-generates professional, structured proposals using customizable PPT templates.It supports real-time multilingual translation for local relevance and includes online editing tools for quick adjustments.',
      msg4: 'Breakthrough Efficiency',
      msg5: 'Cut creation time from days to hours, boosting efficiency by 500%.',
      msg6: 'Assured Quality',
      msg7: 'Maintain professionalism with controlled templates.',
      msg8: 'Seamless Global Adaptation',
      msg9: 'Built-in translation engine simplifies multinational demands.',
      msg10: 'Knowledge Asset Building',
      msg11: 'All proposals can be categorized and archived, building a reusable company knowledge base.',
    },
    // 如何减少商机转化的差旅成本?
    travelExpenses: {
      msg1: 'How to cut travel costs?',
      msg2: `Traditional global expansion relies heavily on travel for deal conversion.This involves either setting up local teams or frequent travel for client visits and demos.Both "face-to-face" models lead to very high travel costs.If efforts fail to yield results, companies face a high-cost, low-resilience situation.`,
      msg3: `A better approach: empower local partners who have native market knowledge.Use a combined toolset: Pain Points Discovery Expert + AI Meeting Assistant + Remote Demo Platform.This creates an efficient "local reach + central support" model with online collaboration from needs analysis to solution verification.`,
      msg4: 'Major Travel Reduction',
      msg5: 'Leveraging local partners and remote tools significantly cuts travel costs.',
      msg6: 'Faster Local Response',
      msg7: 'Local partners enable quicker response to client needs.',
      msg8: 'Optimized Resource Use',
      msg9: 'Central experts can support multiple regions, boosting efficiency by 300%.',
      msg10: 'Reduced Operational Risk',
      msg11: 'Lowers the risk of over-investing in a single market.',
    },
    // 如何快速建立海外客户对你的专业印象?
    majorImpression: {
      msg1: 'How to build trust fast with global clients?',
      msg2: 'Building a professional image globally faces three key challenges:Lacking deep industry insight to demonstrate expert understanding of client pains.Slow, generic responses to client needs.Unfamiliar terminology and slow rebuttals during cross-language communication undermine trust.Relying solely on limited senior consultants makes consistent quality difficult.',
      msg3: `Use Xpirory's tool suite to systematically enhance your team's professionalism.Use the Pain Points Discovery Expert to show deep industry insight, and the Solution Generation Platform for rapid, tailored proposals.Use the AI Meeting Assistant for smooth communication and the Sales Strategy Coach for handling objections.`,
      msg4: 'Demonstrate Expertise',
      msg5: 'Systematic pain point discovery builds immediate credibility.',
      msg6: 'Rapid Response',
      msg7: '500% faster proposal generation demonstrates efficiency.',
      msg8: 'Clear Communication',
      msg9: 'Real-time translation with terminology support ensures native-level fluency.',
      msg10: 'Strategy Support',
      msg11: 'Real-time suggestions prevent hesitations and terminology gaps.',
    },
    // 商机推进不下去了怎么办？
    businessPromote: {
      msg1: 'What if a deal stalls?',
      msg2: 'Stalled deals are a common pain point in global sales.Deals often stall at key stages like ice-breaking, needs analysis, or negotiation.Cross-cultural gaps, weak talking points, or poor strategies can cause client interest to fade.Relying only on individual experience is insufficient for diverse global scenarios.Prolonged stalls waste resources, allow competitors to advance, and erase initial acquisition investment.',
      msg3: 'Use the Sales Strategy Coach​ when a deal stalls to break the deadlock.AI analyzes the stall point in the sales funnel and provides strategies and tailored talk tracks.A built-in library of international business etiquette ensures cultural alignment in communication.',
      msg4: 'Smarter Strategies',
      msg5: 'AI breaks down challenges and provides more effective strategies.',
      msg6: 'Faster Response',
      msg7: 'Generate response talk tracks in minutes, not hours.',
      msg8: 'Cultural Alignment',
      msg9: 'Built-in cultural norms boost client trust by over 50%.',
      msg10: 'Higher Conversion',
      msg11: 'Full pipeline support drives better conversion rates.',
    },
    // 遇到海外客户的挑战/质疑如何应对？
    challengeRespond: {
      msg1: 'How to handle client objections?',
      msg2: 'Handling real-time client objections is a common challenge in global business.Language barriers, cultural gaps, and knowledge asymmetry make it hard to form persuasive responses quickly.Real-time meetings demand instant replies, while written communication requires precise wording.Without proper tools, communication quality varies, risking client trust.',
      msg3: 'A complete solution covering both live meetings and written communication.During calls, the AI Meeting Assistant offers real-time translation and suggests talking points.Its terminology helper explains complex concepts instantly.For emails, the Sales Strategy Coach creates structured response templates.AI tailors the messaging and generates multilingual versions.',
      msg4: 'Faster Response',
      msg5: 'Get AI-suggested replies and strategies instantly.',
      msg6: 'Efficient Communication',
      msg7: 'AI-assisted drafting improves communication efficiency',
      msg8: 'Reduced Errors',
      msg9: 'Structured responses minimize mistakes, boosting satisfaction by 50%.',
      msg10: 'Complete Coverage',
      msg11: 'Two tools work together to handle objections in all scenarios.',
      msg12: 'Al Meeting Assistant',
      msg13: 'Sales Strategy Coach',
    },
    // 遇到竞争对手冲击怎么办？
    opponentImpact: {
      msg1: 'How to tackle competitor challenges?',
      msg2: `Competitor challenges are inevitable in global expansion.Common challenges include sudden price cuts, tailored solutions from rivals, and key technology being copied.Information gaps and slow response times often leave sales teams reacting defensively.Teams lack real-time competitor insights and structured counter-strategies.It's also hard to quickly build compelling responses that work across cultures, risking client trust.This can lead to late-stage deals being lost to competitors.`,
      msg3: `Our Sales Strategy Coach provides AI-powered support to build agile response capabilities across all deal stages.Input the competitive situation - like a rival's quote, feature comparison, or client concerns.The tool automatically generates a breakthrough strategy based on multi-dimensional sales data.It provides a complete response - from strategy analysis and differentiation to value reinforcement and risk assessment.`,
    },
    tools: {
      msg1: 'AI Lead & Conversion Suite',
      msg2: 'AI Lead &<br>Conversion<br>Suite',
      msg3: 'Outsourced Operation<br>Service',
      msg4: 'Download Free PDF: Low-Cost Global Expansion for B2B',
      msg5: 'Try Now',
      msg6: 'Demo our AI Lead Generation Tools? Get a 1-on-1 session with an expert',
      msg7: 'Get Now',
    }
  },
  ...enLocale,
};

export default en;
